import React, { useState, useEffect, useContext, useCallback } from "react";
import { useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { getCountryCodeDigits } from '../../utils/phone';

//import { MenuProfile } from "../../contexts/MenuProfileContext";
import './style.css';
import '../../styles/page-titles.css';
import styled from "styled-components";

import io from 'socket.io-client';


import backgroundChat from "../../assets/img/chat-background.png";
import SearchBar from "../../components/SearchBar";
import * as S from "./stylesProfile";
import {
  SyncContainer,
  SyncCard,
  SyncHeader,
  SyncHeaderContent,
  WhatsAppLogo,
  SyncHeaderText,
  SyncBody,
  StepsList,
  StepItem,
  StepNumber,
  StepText,
  QRCodeWrapper,
  QRCodeContainer,
  QRCodeInner,
  QRCodeTimer,
  QRCodeExpired,
  GenerateButton,
  RegenerateButton,
  InitialState,
  InitialIcon,
  InitialTitle,
  InitialSubtitle,
  LoadingState,
  LoadingSpinner,
  LoadingText
} from "./stylesProfile";
import UserProfile from "./UserProfile"; // Importa o modal
import { SidebarContext } from "../../AppRoutes";
import { MenuProfileContext } from "../../contexts/MenuProfileContext";
import { getQrCodeWhatsapp, renewQrCodeWhatsapp, getWhatsappChats, getWhatsappChatLead, sendTextMessageWhatsapp, removeWhatsappSession, toggleBotStatus, getBotStatusLead, getWhatsappProfilePicture, getMyWhatsappProfilePicture, getWhatsappUnreadCount, markWhatsappMessagesAsRead, getWhatsappConnectionStatus, refreshContactInfoWhatsapp, deleteLeadMessages, getCurrentAccessToken, refreshAccessTokenManually } from "../../services/api";
import Loading from "react-loading";
import { getStoredUser } from '../../utils/safeStorage';
import moment from 'moment-timezone';
import { formatDateTz, nowTz, toTz } from '../../utils/timezone';
import 'moment/locale/pt-br';  // Adiciona a localidade em português
import useImagePreloader from '../../hooks/useImagePreloader';
//import ChatMenu from "../Menu";
import userIcon from "../../assets/img/user-icon.png";
import { ReactComponent as CheckIcon } from "../../assets/svg/check-icon.svg";
import { ReactComponent as StatusIcon } from "../../assets/svg/status-icon.svg";
import { ReactComponent as ChatIcon } from "../../assets/svg/chat-icon.svg";
import { ReactComponent as MenuIcon } from "../../assets/svg/menu-icon.svg";
import { ReactComponent as BackIcon } from "../../assets/svg/arrow-back-icon.svg";
import { FaWhatsapp } from "react-icons/fa";
import { FiSend, FiPauseCircle, FiPlayCircle } from "react-icons/fi"; // Importando o ícone de envio
import { toast } from 'react-toastify';

import Input from "../../components/Input/index";
import UnreadBadge from "../../components/UnreadBadge";

import GlobalStyles from "../../styles/global";

// Hook para detectar mobile
function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);
  React.useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return isMobile;
}

export const WrapperContainerAll = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  flex: 1;
  overflow: hidden;

  @media (max-width: 768px) {
    flex-direction: column;
    height: 100%;
  }
`;

export const WrapperContainerConversa = styled.div`
  flex: 1;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-attachment: fixed;
  background-color: #eae6df;
  background-image: ${props => props.backgroundLoaded ?
    `url(${backgroundChat})` :
    `none`};
  transition: background-image 0.3s ease-in-out;
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;

  @media (max-width: 768px) {
    height: 100%;
    background-attachment: scroll;
    position: relative;
    top: auto;
    left: ${props => props.isMobile && props.showMobileChat ? '0' : 'auto'};
    z-index: auto;
    display: ${props => props.isMobile && !props.showMobileChat ? 'none' : 'flex'};
  }
`;

const WrapperContent = styled.div`
  padding: 8px 63px;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
  }

  @media (max-width: 768px) {
    padding: 8px 16px;
  }
`;

const ChatDate = styled.time`
  display: block;
  background: #e1f3fb;
  padding: 6px 12px;
  border-radius: 7.5px;
  box-shadow: 0 1px 0.5px rgba(0, 0, 0, 0.13);
  font-size: 12.5px;
  margin: 10px auto;
  width: fit-content;
  text-transform: uppercase;
  color: #54656f;

  @media (max-width: 768px) {
    font-size: 11px;
    padding: 5px 10px;
  }
`;

const Message = styled.div`
  background: ${(props) => (props.fromMe ? '#d9fdd3' : '#ffffff')};
  padding: 6px 7px 8px 9px;
  border-radius: 7.5px;
  box-shadow: 0 1px 0.5px rgba(0, 0, 0, 0.13);
  font-size: 14.2px;
  line-height: 19px;
  margin: 1px 0px 1px ${(props) => (props.fromMe ? 'auto' : '0px')};
  width: fit-content;
  max-width: 65%;
  margin-bottom: ${(props) => (props.fromMe ? '2px' : '2px')};
  white-space: pre-wrap;
  word-break: break-word;
  color: #111b21;
  padding-bottom: 20px;

  span {
    font-size: 11px;
    color: rgba(0, 0, 0, 0.45);
    display: inline-flex;
    align-items: center;
    float: right;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    max-width: 85%;
    padding: 6px 7px 8px 9px;
    padding-bottom: 20px;

    span {
      font-size: 11px;
    }
  }
`;

export const Warn = styled.div`
  background: #ffeccf;
  width: fit-content;
  margin: 15px auto;
  padding: 6px 12px 7px;
  font-size: 12.5px;
  border-radius: 7.5px;
  color: #54656f;
  box-shadow: 0 1px 0.5px rgba(0, 0, 0, 0.13);

  @media (max-width: 768px) {
    font-size: 12px;
    margin: 12px auto;
    padding: 6px 10px;
  }
`;

export const WrapperHMC = styled.aside`
  position: relative;
  width: 30%;
  min-width: 340px;
  max-width: 500px;
  height: 100%;
  background: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e9edef;

  @media (max-width: 1200px) {
    width: 35%;
    min-width: 300px;
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: none;
    height: 100%;
    position: relative;
    left: ${props => props.isMobile && props.showMobileChat ? '-100%' : '0'};
    transition: left 0.3s ease;
    z-index: auto;
    display: ${props => props.isMobile && props.showMobileChat ? 'none' : 'flex'};
    border-right: none;
  }
`;

export const WrapperMenu = styled.div`
  position: absolute;
  z-index: 10;
  top: 60px;
  right: 20px;
  background: #fff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
  border-radius: 2px;

  transition: transform 0.1s ease;
  transform-origin: right top;
  transform: scale(0);

  &.active {
    transform: scale(1);
  }
`;

export const ActionWrapperMenu = styled.ul`
  padding: 10px 0px;
`;

export const ActionMenu = styled.li`
  padding: 10px 20px;
  cursor: pointer;
  font-size: 14px;
  color: #3b4a54;
  transition: background 0.2s ease-in-out;

  &:hover {
    background: #f5f6f6;
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.3;

    &:hover {
      background: none;
    }
  }
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  padding: 10px 16px;
  background: #f0f2f5;
  min-height: 59px;

  @media (max-width: 768px) {
    padding: 10px 12px;
    position: relative;
    padding-right: 60px;
  }

  path{
    stroke: gray;
    --color: black;
    --background: black;
  }
`;

export const ContactPhoto = styled.div`
  margin-right: 15px;
  flex-shrink: 0;

  img {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    object-fit: cover;
  }

  @media (max-width: 768px) {
    margin-right: 12px;

    img {
      width: 36px;
      height: 36px;
    }
  }
`;

export const ContactName = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  color: #111b21;
  flex: 1;

  @media (max-width: 768px) {
    font-size: 15px;
  }
`;

export const MobileBackButton = styled.button`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    padding: 8px;
    margin-right: 10px;
    cursor: pointer;
    color: #54656f;
    font-size: 20px;
  }
`;

export const WrapperChat = styled.div`
  padding: 10px 16px;
  background: #f0f2f5;
  width: 100%;
  flex-shrink: 0;
  min-height: 62px;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    padding: 8px 10px;
    min-height: 58px;

    form {
      gap: 8px;
    }
  }
`;

export const WrapperListContacts = styled.div`
  display: flex;
  align-items: center;
  background: ${(props) => (props.isSelected ? '#eaeaea' : 'white')};
  cursor: pointer;
  padding: 10px;  /* Adicionado padding para espaçamento */
  border-bottom: 1px solid #eee;
  &:hover {
    background: #f4f4f4;
  }
  
  @media (max-width: 768px) {
    padding: 15px 10px;
    
    &:active {
      background: #e0e0e0;
    }
  }
`;

export const ContactPhotoListContacts = styled.div`
  flex: 0 0 60px;  /* Define a largura fixa da área da foto */
  padding: 10px;

  img {
    border-radius: 100%;
    width: 100%;  /* Garante que a imagem ocupe a largura total do contêiner */
  }
  
  @media (max-width: 768px) {
    flex: 0 0 50px;
    padding: 8px;
  }
`;

export const ContactNameAndTime = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  span {
    font-size: 16px;
    font-weight: 400;
    color: #111b21;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 70%;
  }

  p {
    font-size: 12px;
    color: #667781;
    margin-left: 10px;
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    span {
      font-size: 15px;
      max-width: 65%;
    }

    p {
      font-size: 11px;
    }
  }
`;

export const ContactMessage = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 2px;

  svg {
    margin-right: 4px;
    color: #667781;
    flex-shrink: 0;
  }

  p {
    font-size: 14px;
    color: #667781;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    line-height: 20px;
  }

  @media (max-width: 768px) {
    p {
      font-size: 13px;
    }
  }
`;

export const MessageDataWrapper = styled.div`
  flex: 1;
  padding-right: 15px;
  overflow: hidden;  /* Garante que o conteúdo não extrapole os limites */
  display: flex;
  flex-direction: column;
  
  @media (max-width: 768px) {
    padding-right: 10px;
  }
`;

export const WrapperListHeader = styled.div`
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  
  @media (max-width: 768px) {
    border-right: none;
  }
`;

export const HeaderListHeader = styled.header`
  background-color: #f0f2f5;
  width: 100%;
  padding: 10px 16px;
  min-height: 59px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    padding: 10px 12px;
    padding-right: 60px;
  }
`;

export const UserImage = styled.div`
  margin-right: auto;
  cursor: pointer;

  img {
    border-radius: 100%;
  }
  
  @media (max-width: 768px) {
    img {
      width: 35px;
      height: 35px;
    }
  }
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;

  svg {
    width: 50px;
    cursor: pointer;

    &:not(:last-child) {
      cursor: not-allowed;
      opacity: 0.3;
    }
  }
  
  @media (max-width: 768px) {
    svg {
      width: 40px;
    }
  }
`;

const Teste = styled.div`
  display: flex;
  margin-left: ${({ sidebar }) => (sidebar ? '250px' : '100px')};
  height: calc(100vh - 56px);
  width: calc(100vw - ${({ sidebar }) => (sidebar ? '250px' : '100px')});
  transition: margin-left 200ms ease, width 200ms ease;
  background-color: #eae6df;
  overflow: hidden;
  z-index: 9;
  padding: 0;

  @media (max-width: 768px) {
    margin-left: 0;
    padding: 0;
    height: calc(100vh - 56px);
    width: 100vw;
    position: relative;
    top: auto;
    left: 0;
    z-index: 1;
  }
`;

// Container específico para WhatsApp - substitui o Container do global.js
const WhatsAppContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #eae6df;
  position: relative;
  overflow: hidden;
`;

// Helper Function to Group Messages by Date
const groupMessagesByDate = (messages) => {
  return messages.reduce((acc, message) => {
    const date = formatDateTz(message.createdAt, 'YYYY-MM-DD');
    if (!acc[date]) {
      acc[date] = [];
    }
    acc[date].push(message);
    return acc;
  }, {});
};



const WhatsAppWeb = () => {
  const { t, i18n } = useTranslation('whatsapp');
  moment.locale(i18n.language === 'en-US' ? 'en' : 'pt-br');
  const userParse = getStoredUser();

  const empresa = localStorage.getItem('empresa');
  const empresaParse = JSON.parse(empresa);
  const empresaID = empresaParse._id;
  const token = getCurrentAccessToken();

  const location = useLocation(); // Captura o state passado pelo navigate
  const navigate = useNavigate(); // Para limpar o state após processar

  const isMobile = useIsMobile();
  const [showMobileChat, setShowMobileChat] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  //const { openMenu } = useContext(MenuProfileContext);
  const { isOpen, openMenu, closeMenu } = useContext(MenuProfileContext);
  //const openMenu = () => setIsMenuOpen(true);
  const menuRef = useRef(null);
  const [message, setMessage] = useState("");
  const { sidebar } = useContext(SidebarContext);; //TESTANDO CONST NO AppROUTES
  const [isSubmitting, setIsSubmitting] = useState(false);
  // 📱 Estados do QR Code - MELHORADO
  const [qrCodeImg, setQrCodeImg] = useState('');
  const [generatingQrCode, setGeneratingQrCode] = useState(false);
  const [isLoged, setIsLoged] = useState(false);
  const [checkingConnection, setCheckingConnection] = useState(true); // Loading inicial enquanto verifica status
  const [qrCodeExpired, setQrCodeExpired] = useState(false);
  const [qrCodeTimeLeft, setQrCodeTimeLeft] = useState(0);
  const [userRequestedQrCode, setUserRequestedQrCode] = useState(false); // 🔧 NOVO: Controla se usuário solicitou QR Code
  const [showRegenerateButton, setShowRegenerateButton] = useState(false);
  const [qrCodeFailed, setQrCodeFailed] = useState(false); // 🔧 QR code falhou (instância travada)

  //const [socket, setSocket] = useState(null);
  const [chats, setChats] = useState([]);
  const [loading, setLoading] = useState(true);

  const [selectedChat, setSelectedChat] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [messagesLeadChannel, setMessagesLeadChannel] = useState([]);
  const timeoutRef = useRef(null); // UseRef to store the timeout ID
  const isMountedRef = useRef(true); // Para saber se o componente está montado
  const cancelQrCodeFetchRef = useRef(false); // Flag para cancelar a execução do fetch
  // 📱 Refs para QR Code melhorado
  const qrCodeTimerRef = useRef(null);
  const countdownTimerRef = useRef(null);
  // 🕒 Timer "QR pendente": quando backend devolve qr_pending=true ou QR vazio,
  // aguardamos o socket entregar o QR via webhook (qrcode-updated da Evolution)
  // antes de mostrar "Conexão travada". Sem isso, o usuário vê falsa falha
  // enquanto o QR está sendo gerado (5-10s reais de delay na Evolution).
  const pendingQrTimerRef = useRef(null);
  const [botPausado, setBotPausado] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [refreshingContact, setRefreshingContact] = useState(false); // Estado para animação de refresh
  const [messagesCache, setMessagesCache] = useState(new Map());
  const [loadingMessages, setLoadingMessages] = useState(false);

  // **📌 ESTADOS PARA PAGINAÇÃO DE MENSAGENS**
  const [messagesPage, setMessagesPage] = useState(0);
  const [hasMoreMessages, setHasMoreMessages] = useState(true);
  const [loadingMoreMessages, setLoadingMoreMessages] = useState(false);
  const messagesContainerRef = useRef(null);
  const [preloadingChats, setPreloadingChats] = useState(false);
  const [preloadProgress, setPreloadProgress] = useState({ current: 0, total: 0 });
  const [hasPreloaded, setHasPreloaded] = useState(false); // eslint-disable-line no-unused-vars
  const [raceConditionsFixed, setRaceConditionsFixed] = useState(0);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const fetchingChatsRef = useRef(false);

  // **📌 ESTADO PARA IMAGEM DE PERFIL DO PRÓPRIO USUÁRIO**
  const [myProfilePicture, setMyProfilePicture] = useState(null);

  // **📌 ESTADO PARA CONTROLAR SE DEVE ROLAR PARA O BOTTOM**
  const [shouldScrollToBottom, setShouldScrollToBottom] = useState(true);

  // **📌 ESTADO PARA CONTROLAR SE ACABOU DE ABRIR UMA CONVERSA**
  const [justOpenedChat, setJustOpenedChat] = useState(false);
  const justOpenedTimerRef = useRef(null);

  // **📌 ESTADO PARA CONTAGEM DE MENSAGENS NÃO LIDAS**
  const [unreadCounts, setUnreadCounts] = useState({});

  // **📌 PRELOAD DA IMAGEM DE BACKGROUND USANDO HOOK CUSTOMIZADO**
  const { loaded: backgroundLoaded, error: backgroundError, progress: backgroundProgress } = useImagePreloader(backgroundChat, 3000);

  const [, setPage] = useState(0); // Página inicial
  const [hasMoreChats, setHasMoreChats] = useState(true); // Se ainda há chats para carregar
  const chatsContainerRef = useRef(null); // Referência ao container de chats
  const [loadingMore, setLoadingMore] = useState(false); // Para evitar requisições duplicadas

  // **📌 ESTADOS PARA MENU DE CONTEXTO (BOTÃO DIREITO)**
  const [contextMenu, setContextMenu] = useState({
    visible: false,
    x: 0,
    y: 0,
    chat: null
  });

  // **📌 CONTROLE PARA EVITAR MÚLTIPLOS TOASTS E EXECUÇÕES PARALELAS**
  const [isCreatingConversation, setIsCreatingConversation] = useState(false);
  const lastErrorToastRef = useRef(null);
  const conversationTimeoutRef = useRef(null);
  const processedLocationRef = useRef(null); // Para controlar se já processou o location.state
  const debounceTimeoutRef = useRef(null); // Para controlar o debounce
  const lastErrorMessageRef = useRef(''); // Para evitar toasts de erro duplicados
  const lastErrorTimeRef = useRef(0); // Para controlar timing dos toasts



  // **📌 SOCKET PRINCIPAL PARA WHATSAPP**
  const [mainSocket, setMainSocket] = useState(null);

  const isDevelopment = window.location.hostname === 'localhost';
  const apiUrl = isDevelopment
    ? process.env.REACT_APP_SERVER_URL_DEV
    : process.env.REACT_APP_SERVER_URL_PROD;

  // **📌 FUNÇÃO PARA MOSTRAR TOAST DE ERRO CONTROLADO (EVITA MÚLTIPLOS TOASTS)**
  const showErrorToast = useCallback((message, autoCloseTime = 5000) => {
    const now = Date.now();

    // **🔧 EVITAR TOASTS DUPLICADOS: Se a mesma mensagem foi exibida há menos de 3 segundos, ignorar**
    if (lastErrorMessageRef.current === message && (now - lastErrorTimeRef.current) < 3000) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🚫 Toast duplicado ignorado:', message);
      return;
    }

    // Limpar timeout anterior se existir
    if (conversationTimeoutRef.current) {
      clearTimeout(conversationTimeoutRef.current);
    }

    // Cancelar toast anterior se existir
    if (lastErrorToastRef.current) {
      toast.dismiss(lastErrorToastRef.current);
    }

    // **🔧 ARMAZENAR INFORMAÇÕES DO ÚLTIMO TOAST**
    lastErrorMessageRef.current = message;
    lastErrorTimeRef.current = now;

    // Mostrar novo toast e armazenar referência
    lastErrorToastRef.current = toast.error(message, {
      position: "top-right",
      autoClose: autoCloseTime,
      onClose: () => {
        lastErrorToastRef.current = null;
        // **🔧 LIMPAR CACHE DE MENSAGEM APÓS 1 SEGUNDO DO FECHAMENTO**
        setTimeout(() => {
          if (lastErrorMessageRef.current === message) {
            lastErrorMessageRef.current = '';
          }
        }, 1000);
      }
    });
  }, []);

  // **📌 FUNÇÃO PARA MARCAR MENSAGENS COMO LIDAS**
  const markChatAsRead = useCallback(async (chatId) => {
    try {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`📖 Marcando mensagens como lidas para chat: ${chatId}`);
      const response = await markWhatsappMessagesAsRead(empresaID, chatId, token);
      if (response.data && response.data.status === 200) {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`✅ Mensagens marcadas como lidas com sucesso para chat: ${chatId}`);

        // Atualizar contagem local
        setUnreadCounts(prevCounts => {
          const newCounts = { ...prevCounts };
          delete newCounts[chatId]; // Remove a contagem para este chat
          return newCounts;
        });

        // Atualizar contagem geral
        try {
          const response = await getWhatsappUnreadCount(empresaID, token);
          if (response.data && response.data.status === 200) {
            setUnreadCounts(response.data.unreadCounts);
          }
        } catch (error) {
          process.env.REACT_APP_ISDEVELOP === 'true' && console.error('❌ Erro ao buscar contagem de mensagens não lidas:', error);
        }
      } else {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`⚠️ Resposta inesperada ao marcar como lidas:`, response.data);
      }
    } catch (error) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.error(`❌ Erro ao marcar mensagens como lidas para chat ${chatId}:`, error);
    }
  }, [empresaID, token]);

  // **📌 FUNÇÃO PARA VERIFICAR STATUS REAL DA EVOLUTION API**
  const checkConnectionStatus = useCallback(async (source = 'unknown') => {
    if (!isMountedRef.current) return false;

    try {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`🔍 [CHECK STATUS] Verificando status REAL da Evolution API... (fonte: ${source})`);
      const response = await getWhatsappConnectionStatus(empresaID);

      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('📡 [CHECK STATUS] Resposta da Evolution API:', response.data);

      const isConnected = response.data.isConnected;
      const connectionState = response.data.connectionState;

      // ✅ SEMPRE USAR STATUS REAL DA EVOLUTION API (NUNCA DO BANCO)
      if (isConnected && connectionState === 'open') {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('✅ [CHECK STATUS] WhatsApp REALMENTE conectado na Evolution API!');
        setIsLoged(true);
        setGeneratingQrCode(false);
        setQrCodeImg('');
        clearQrCodeTimers(); // Limpar timers se conectado
        setCheckingConnection(false);
        return true; // Conectado
      } else {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`📱 [CHECK STATUS] WhatsApp REALMENTE desconectado na Evolution API (${connectionState})`);
        setIsLoged(false);
        setCheckingConnection(false);
        return false; // Desconectado
      }
    } catch (error) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.error('❌ [CHECK STATUS] Erro ao verificar status na Evolution API:', error);
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('📱 [CHECK STATUS] Assumindo desconectado devido ao erro');
      setIsLoged(false);
      setCheckingConnection(false);
      return false; // Em caso de erro, assumir desconectado
    }
  }, [empresaID]);

  // 📱 FUNÇÃO PARA LIMPAR TIMERS DO QR CODE
  const clearQrCodeTimers = () => {
    if (qrCodeTimerRef.current) {
      clearTimeout(qrCodeTimerRef.current);
      qrCodeTimerRef.current = null;
    }
    if (countdownTimerRef.current) {
      clearInterval(countdownTimerRef.current);
      countdownTimerRef.current = null;
    }
    // 🕒 Limpar também o timer "QR pendente" — evita falsa falha após unmount/refresh
    if (pendingQrTimerRef.current) {
      clearTimeout(pendingQrTimerRef.current);
      pendingQrTimerRef.current = null;
    }
  };

  // **📌 DEBUG: LOG DE ERROS DO BACKGROUND**
  useEffect(() => {
    if (backgroundError) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.error('🚨 [BACKGROUND ERROR]:', backgroundError);
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('📊 [BACKGROUND DEBUG]:', {
        backgroundLoaded,
        backgroundProgress: `${backgroundProgress}%`,
        backgroundChat: backgroundChat?.substring(0, 50) + '...',
        isDevelopment: process.env.NODE_ENV === 'development',
        baseURL: window.location.origin
      });

      // Tentar carregar a imagem diretamente no console para debug
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🔍 [DEBUG] Testando carregamento direto da imagem:');
      const testImg = new Image();
      testImg.onload = () => process.env.REACT_APP_ISDEVELOP === 'true' && console.log('✅ [DEBUG] Imagem carrega OK diretamente');
      testImg.onerror = (e) => process.env.REACT_APP_ISDEVELOP === 'true' && console.error('❌ [DEBUG] Imagem falha ao carregar diretamente:', e);
      testImg.src = backgroundChat;
    } else if (backgroundLoaded && backgroundProgress === 100) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🎉 [BACKGROUND] Carregamento concluído com sucesso!');
      // Toast sutil apenas no desenvolvimento para debug
      /*if (process.env.NODE_ENV === 'development') {
        setTimeout(() => {
          toast.success('🎨 Background do chat carregado', {
            position: "bottom-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
          });
        }, 500);
      }*/
    }
  }, [backgroundError, backgroundLoaded, backgroundProgress]);

  // **📌 FUNÇÃO PARA BUSCAR IMAGEM DE PERFIL (OTIMIZADA)**
  const fetchProfilePicture = useCallback(async (chat, forceUpdate = false, priority = 'normal') => {
    // **📌 CACHE MAIS INTELIGENTE - 30 DIAS AO INVÉS DE 7 DIAS**
    const cacheValidityDays = 30;
    const hasRecentProfilePicture = chat.channel_data?.whatsapp?.profile_picture_updateAt &&
      new Date() - new Date(chat.channel_data.whatsapp.profile_picture_updateAt) < cacheValidityDays * 24 * 60 * 60 * 1000;

    // **📌 VERIFICAÇÕES PARA EVITAR REQUISIÇÕES DESNECESSÁRIAS**
    if (!forceUpdate && chat.channel_data?.whatsapp?.profile_picture && hasRecentProfilePicture) {
      return;
    }

    // **📌 EVITAR MÚLTIPLAS REQUISIÇÕES SIMULTÂNEAS PARA O MESMO CHAT**
    const requestKey = `profile_picture_${chat._id}`;
    if (window.profilePictureRequests && window.profilePictureRequests[requestKey]) {
      return;
    }

    // **📌 THROTTLE: Só buscar imagem se passou pelo menos 5 segundos da última requisição**
    const lastRequestTime = window.profilePictureLastRequest?.[requestKey] || 0;
    const now = Date.now();
    if (!forceUpdate && (now - lastRequestTime) < 5000) {
      return;
    }

    // Marcar requisição como em andamento
    if (!window.profilePictureRequests) window.profilePictureRequests = {};
    if (!window.profilePictureLastRequest) window.profilePictureLastRequest = {};
    window.profilePictureRequests[requestKey] = true;
    window.profilePictureLastRequest[requestKey] = now;

    try {
      const response = await getWhatsappProfilePicture(chat._id, token);

      if (response.data && response.data.status === 200) {
        const newPictureUrl = response.data.profilePictureUrl || null;

        // Limpar cache de falha se recebemos uma nova URL válida (ou null para usar fallback)
        const failedKey = `img_failed_${chat._id}`;
        if (window.imgFailedCache) {
          if (newPictureUrl) {
            delete window.imgFailedCache[failedKey]; // Nova URL válida, limpar flag de falha
          } else if (!window.imgFailedCache[failedKey]) {
            window.imgFailedCache[failedKey] = Date.now(); // Marcar como sem foto para evitar retry
          }
        }

        // Atualizar o chat na lista local (incluindo quando URL é null para limpar foto expirada)
        setChats(prevChats =>
          prevChats.map(c =>
            c._id === chat._id
              ? {
                ...c,
                channel_data: {
                  ...c.channel_data,
                  whatsapp: {
                    ...c.channel_data?.whatsapp,
                    profile_picture: newPictureUrl,
                    profile_picture_updateAt: new Date().toISOString()
                  }
                }
              }
              : c
          )
        );

        // Se é o chat selecionado, atualizar também
        if (selectedChat && selectedChat._id === chat._id) {
          setSelectedChat(prev => ({
            ...prev,
            channel_data: {
              ...prev.channel_data,
              whatsapp: {
                ...prev.channel_data?.whatsapp,
                profile_picture: newPictureUrl,
                profile_picture_updateAt: new Date().toISOString()
              }
            }
          }));
        }
      }
    } catch (error) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.error(`❌ Erro ao buscar imagem de perfil para ${chat.name}:`, error);
    } finally {
      // Remover marcação de requisição em andamento
      if (window.profilePictureRequests) {
        delete window.profilePictureRequests[requestKey];
      }
    }
  }, [selectedChat, token]);

  // **📌 FUNÇÃO PARA BUSCAR CONTAGEM DE MENSAGENS NÃO LIDAS**
  const fetchUnreadCounts = useCallback(async () => {
    try {
      const response = await getWhatsappUnreadCount(empresaID, token);
      if (response.data && response.data.status === 200) {
        setUnreadCounts(response.data.unreadCounts);
        //process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`📊 Contagens de mensagens não lidas atualizadas:`, response.data.unreadCounts);
      }
    } catch (error) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.error('❌ Erro ao buscar contagem de mensagens não lidas:', error);
    }
  }, [empresaID, token]);

  // **📌 FUNÇÃO PARA BUSCAR IMAGENS EM LOTE DE FORMA INTELIGENTE (OTIMIZADA)**
  const fetchProfilePicturesBatch = (chats) => {
    const cacheValidityDays = 30; // Aumentado para 30 dias
    const chatsNeedingImages = chats.filter(chat => {
      const hasImage = chat.channel_data?.whatsapp?.profile_picture;
      const hasRecentUpdate = chat.channel_data?.whatsapp?.profile_picture_updateAt &&
        new Date() - new Date(chat.channel_data.whatsapp.profile_picture_updateAt) < cacheValidityDays * 24 * 60 * 60 * 1000;

      return !hasImage || !hasRecentUpdate;
    });

    if (chatsNeedingImages.length === 0) {
      return;
    }

    // **📌 LIMITAR A APENAS 3 CHATS MAIS VISÍVEIS PARA REDUZIR REQUISIÇÕES**
    const priorityChats = chatsNeedingImages.slice(0, 3);

    // **📌 DELAY MAIOR ENTRE REQUISIÇÕES PARA EVITAR SOBRECARGA**
    priorityChats.forEach((chat, index) => {
      setTimeout(() => {
        fetchProfilePicture(chat, false, 'high');
      }, index * 1000); // 1 segundo entre cada requisição
    });
  };

  // **📌 FUNÇÃO PARA PRÉ-CARREGAR TODAS AS CONVERSAS**
  // eslint-disable-next-line no-unused-vars
  const preloadAllChats = async (chatList) => {
    if (!chatList || chatList.length === 0) return;

    setPreloadingChats(true);

    // Priorizar conversas com mensagens mais recentes
    const sortedChats = [...chatList].sort((a, b) => {
      const dateA = new Date(a.message?.messageDate || a.message?.createdAt || 0);
      const dateB = new Date(b.message?.messageDate || b.message?.createdAt || 0);
      return dateB - dateA;
    });

    // Limitar a 15 conversas mais recentes para não sobrecarregar
    const chatsToPreload = sortedChats.slice(0, 15);
    setPreloadProgress({ current: 0, total: chatsToPreload.length });

    const batchSize = 3; // Carregar 3 conversas por vez

    try {
      for (let i = 0; i < chatsToPreload.length; i += batchSize) {
        const batch = chatsToPreload.slice(i, i + batchSize);

        // Carregar batch em paralelo
        const batchPromises = batch.map(async (chat) => {
          try {
            // Verificar se já não está no cache
            if (messagesCache.has(chat._id)) {
              return;
            }
            const response = await getWhatsappChatLead(empresaID, chat._id, 0, 30, token);

            if (response.data && response.data.messages && response.data.messages[0] && response.data.messages[0].data) {
              const messages = response.data.messages[0].data;

              // Armazenar no cache
              setMessagesCache(prevCache => {
                const newCache = new Map(prevCache);
                newCache.set(chat._id, messages);
                return newCache;
              });

              //process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`✅ ${messages.length} mensagens pré-carregadas para ${chat.name}`);
            } else {
              // Armazenar array vazio para conversas sem mensagens
              setMessagesCache(prevCache => {
                const newCache = new Map(prevCache);
                newCache.set(chat._id, []);
                return newCache;
              });
              //process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`📭 Conversa vazia pré-carregada: ${chat.name}`);
            }
          } catch (error) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error(`❌ Erro ao pré-carregar ${chat.name}:`, error);
            // Armazenar array vazio em caso de erro
            setMessagesCache(prevCache => {
              const newCache = new Map(prevCache);
              newCache.set(chat._id, []);
              return newCache;
            });
          }
        });

        // Aguardar batch atual
        await Promise.all(batchPromises);

        // Atualizar progresso
        const completed = Math.min(i + batchSize, chatsToPreload.length);
        setPreloadProgress({ current: completed, total: chatsToPreload.length });

        // Delay dinâmico baseado na quantidade de conversas
        if (i + batchSize < chatsToPreload.length) {
          const delay = chatsToPreload.length > 10 ? 400 : 200; // Delay maior para listas maiores
          await new Promise(resolve => setTimeout(resolve, delay));
        }
      }

      process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`🎉 Pré-carregamento concluído! ${chatsToPreload.length} conversas armazenadas no cache.`);
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`💾 Cache atual contém ${messagesCache.size} conversas.`);

    } catch (error) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.error('❌ Erro no pré-carregamento:', error);
      toast.error(`⚠️ ${t('toasts.preloadError')}`, {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      setPreloadingChats(false);
      setPreloadProgress({ current: 0, total: 0 });
    }
  };

  const fetchChats = useCallback(async (newPage, append = false, source = 'unknown') => {
    process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🎯 fetchChats INICIADO - newPage:", newPage, "append:", append, "source:", source);
    process.env.REACT_APP_ISDEVELOP === 'true' && console.log("📋 Parâmetros - empresaID:", empresaID, "token:", token ? "presente" : "ausente");

    // 🛡️ EVITAR EXECUÇÕES DUPLICADAS
    if (fetchingChatsRef.current && !append) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🚫 fetchChats já em execução, ignorando chamada duplicada de:", source);
      return;
    }

    if (!append) {
      fetchingChatsRef.current = true;
    }

    try {
      const pageSize = 30;
      const query = searchQuery;

      process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🔄 Carregando página:", newPage);
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🔍 Query de busca:", query);

      const response = await getWhatsappChats(empresaID, newPage, pageSize, query, token);

      const newChats = response.data.messages[0].data;

      if (newChats.length === 0) {
        setHasMoreChats(false); // Se não há mais chats, parar carregamento
      }

      setChats((prevChats) => {
        let finalChats;
        if (append) {
          // Remove duplicatas ao adicionar novos chats
          const existingIds = new Set(prevChats.map(chat => chat._id));
          const uniqueNewChats = newChats.filter(chat => !existingIds.has(chat._id));
          finalChats = [...prevChats, ...uniqueNewChats];
        } else {
          // Remove duplicatas nos chats iniciais
          const uniqueChats = newChats.filter((chat, index, self) =>
            index === self.findIndex(c => c._id === chat._id)
          );
          finalChats = uniqueChats;

          // **📌 PRÉ-CARREGAMENTO DESABILITADO PARA MELHOR PERFORMANCE**
          // O pré-carregamento será feito apenas quando o usuário selecionar um chat
          if (isInitialLoad) {
            setIsInitialLoad(false);
            setHasPreloaded(true); // Marcar como "pré-carregado" para evitar tentativas futuras
          }
        }
        // **📌 BUSCAR IMAGENS DE PERFIL APENAS NO CARREGAMENTO INICIAL (OTIMIZADO)**
        if (!append && finalChats.length > 0) {
          // Delay maior para evitar sobrecarga
          setTimeout(() => {
            fetchProfilePicturesBatch(finalChats);
          }, 2000); // 2 segundos de delay

          // **📌 BUSCAR CONTAGEM DE MENSAGENS NÃO LIDAS APENAS UMA VEZ**
          setTimeout(() => {
            fetchUnreadCounts();
          }, 1000); // 1 segundo de delay
        }

        return finalChats;
      });
      setLoading(false);
      setLoadingMore(false);
    } catch (err) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.error("❌ Erro ao carregar chats:", err);
      process.env.REACT_APP_ISDEVELOP === 'true' && console.error("📊 Detalhes do erro:", {
        message: err.message,
        status: err.response?.status,
        data: err.response?.data,
        config: err.config
      });
      setLoading(false);
      setLoadingMore(false);
    } finally {
      // 🛡️ SEMPRE RESETAR FLAG DE FETCHING
      if (!append) {
        fetchingChatsRef.current = false;
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [empresaID, token, searchQuery]); // Removido dependências de funções que causam loops

  const fetchQrCode = async (source = 'unknown') => {
    process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`🔍 [FETCH QR CODE] Iniciado por: ${source}`);

    if (!isMountedRef.current) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🚫 [FETCH QR CODE] Componente não montado, cancelando');
      return;
    }

    // **📌 PRIMEIRO VERIFICAR STATUS DE CONEXÃO**
    process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🔍 [FETCH QR CODE] Verificando status de conexão...');
    const isConnected = await checkConnectionStatus(`fetchQrCode_${source}`);
    if (isConnected) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('✅ [FETCH QR CODE] Já conectado, cancelando geração de QR Code');
      clearQrCodeTimers(); // Limpar timers se conectado
      return; // Se conectado, não precisa gerar QR Code
    }

    // **📌 SE DESCONECTADO, GERAR QR CODE**
    process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`🔄 [FETCH QR CODE] Desconectado, gerando QR Code... (fonte: ${source})`);
    setGeneratingQrCode(true);
    setQrCodeFailed(false);

    getQrCodeWhatsapp(empresaID).then((response) => {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('📡 QR Code Response completa:', response.data);

      if (!isMountedRef.current) return;

      // 🔧 TRATAMENTO MELHORADO DA RESPOSTA DO QR CODE (ALINHADO COM BACKEND)
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('📊 Resposta completa da API:', response.data);

      // Verificar se já está conectado
      if (response.data.isConnected) {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('✅ WhatsApp já está conectado segundo a API');
        setIsLoged(true);
        setGeneratingQrCode(false);
        setQrCodeImg('');
        clearQrCodeTimers();
        return;
      }

      let qrCodeData = null;
      let ttl = 45; // TTL padrão

      // Verificar diferentes formatos de resposta da Evolution API
      if (response.data.qrcode) {
        const qrData = response.data.qrcode;

        if (qrData.qr) {
          // Formato: { qrcode: { qr: "data:image/png;base64,..." } }
          qrCodeData = qrData.qr;
          process.env.REACT_APP_ISDEVELOP === 'true' && console.log('📱 QR Code encontrado em qrcode.qr');
        } else if (qrData.base64) {
          // Formato: { qrcode: { base64: "data:image/png;base64,..." } }
          qrCodeData = qrData.base64;
          process.env.REACT_APP_ISDEVELOP === 'true' && console.log('📱 QR Code encontrado em qrcode.base64');
        } else if (typeof qrData === 'string') {
          // Formato: { qrcode: "data:image/png;base64,..." }
          qrCodeData = qrData;
          process.env.REACT_APP_ISDEVELOP === 'true' && console.log('📱 QR Code encontrado como string direta');
        }

        // Extrair TTL se disponível
        if (qrData.ttl) {
          ttl = Math.max(1, qrData.ttl - Math.floor(Date.now() / 1000));
          process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`⏱️ TTL extraído do backend: ${ttl} segundos`);
        }
      }

      if (qrCodeData) {
        // Validar se é uma imagem base64 válida
        if (qrCodeData.startsWith('data:image/')) {
          // Cancelar timer pendente (QR chegou via response, não via socket)
          if (pendingQrTimerRef.current) {
            clearTimeout(pendingQrTimerRef.current);
            pendingQrTimerRef.current = null;
          }
          setQrCodeImg(qrCodeData);
          process.env.REACT_APP_ISDEVELOP === 'true' && console.log('✅ QR Code definido com sucesso - Tamanho:', qrCodeData.length);
          setGeneratingQrCode(false);

          // 📱 INICIAR TIMER COM TTL DO BACKEND
          startQrCodeTimer(ttl);
        } else {
          process.env.REACT_APP_ISDEVELOP === 'true' && console.error('❌ QR Code não é uma imagem base64 válida:', qrCodeData.substring(0, 100));
          setGeneratingQrCode(false);
        }
      } else {
        // 🕒 QR ainda não pronto. Backend pode ter sinalizado qr_pending=true.
        // Aguardamos até 12s pelo socket (whatsapp_qrcode_update) antes de
        // marcar como falha. Cenário documentado: incidente X Madruga 15/05.
        const isPending = response.data?.qr_pending === true;
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log(
          `⏳ QR Code ainda não pronto (qr_pending=${isPending}). Aguardando socket por 12s...`
        );

        // Manter UI em "Gerando QR Code..." (NÃO setar generatingQrCode=false)
        // O socket listener vai limpar isso quando o QR chegar.

        // Cancelar timer pendente anterior, se houver
        if (pendingQrTimerRef.current) {
          clearTimeout(pendingQrTimerRef.current);
        }

        pendingQrTimerRef.current = setTimeout(() => {
          if (!isMountedRef.current) return;
          process.env.REACT_APP_ISDEVELOP === 'true' && console.warn(
            '⏰ Timeout aguardando QR via socket — marcando como falha'
          );
          setGeneratingQrCode(false);
          setQrCodeFailed(true);
          pendingQrTimerRef.current = null;
        }, 12000);
      }

      // ❌ REMOVIDO: Lógica antiga de regeneração automática
      // Agora usamos timer fixo de 20 segundos com botão manual de regeneração

      // ❌ REMOVIDO: Verificação periódica antiga - agora usamos socket listeners e timer fixo de 20s

    }).catch((error) => {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.error('Erro ao buscar QR Code:', error);
      setGeneratingQrCode(false);

      // 🚀 TRATAMENTO ESPECIAL PARA AUTO-CRIAÇÃO DE INSTÂNCIA
      if (error.response?.status === 500 && error.response?.data?.error?.includes('configurar WhatsApp automaticamente')) {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🚀 [FETCH QR CODE] Detectada auto-criação de instância - retry em 5 segundos...');

        if (isMountedRef.current && !cancelQrCodeFetchRef.current) {
          timeoutRef.current = setTimeout(() => {
            if (isMountedRef.current && !cancelQrCodeFetchRef.current) {
              process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🔄 [FETCH QR CODE] Retry após auto-criação');
              fetchQrCode('auto_creation_retry');
            }
          }, 5000); // Retry mais rápido para auto-criação
        }
        return;
      }

      // Tratamento para outros erros - retry normal
      if (isMountedRef.current && !cancelQrCodeFetchRef.current) {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🔄 [FETCH QR CODE] Erro - tentando novamente em 10 segundos...');
        timeoutRef.current = setTimeout(() => {
          if (isMountedRef.current && !cancelQrCodeFetchRef.current) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🔄 [FETCH QR CODE] Retry após erro');
            fetchQrCode('error_retry');
          }
        }, 10000);
      }
    }).finally(() => {
      if (isMountedRef.current) {
        setGeneratingQrCode(false);
      }
    });
  };

  // 📱 FUNÇÃO MELHORADA PARA GERENCIAR QR CODE COM TIMER DE 45 SEGUNDOS (ALINHADO COM BACKEND)
  const startQrCodeTimer = (initialTtl = 45) => {
    // Limpar timers existentes
    if (qrCodeTimerRef.current) {
      clearTimeout(qrCodeTimerRef.current);
    }
    if (countdownTimerRef.current) {
      clearInterval(countdownTimerRef.current);
    }

    // Resetar estados
    setQrCodeExpired(false);
    setShowRegenerateButton(false);
    setQrCodeTimeLeft(initialTtl); // TTL dinâmico (padrão 45 segundos)

    process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`⏱️ Iniciando timer de QR Code: ${initialTtl} segundos`);

    // Timer de countdown (atualiza a cada segundo)
    countdownTimerRef.current = setInterval(() => {
      setQrCodeTimeLeft(prev => {
        if (prev <= 1) {
          // QR Code expirou
          setQrCodeExpired(true);
          setShowRegenerateButton(true);
          clearInterval(countdownTimerRef.current);

          process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`⏰ QR Code expirou após ${initialTtl} segundos`);

          // 🔧 REGENERAÇÃO AUTOMÁTICA DESABILITADA - Usuário deve clicar manualmente
          // setTimeout(() => {
          //   if (!isLoged && isMountedRef.current) {
          //     process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🔄 Regenerando QR Code automaticamente via nova rota...');
          //     regenerateQrCodeViaAPI('automatic_expiry');
          //   }
          // }, 2000); // Delay de 2 segundos antes de regenerar

          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    // Timer principal baseado no TTL
    qrCodeTimerRef.current = setTimeout(() => {
      setQrCodeExpired(true);
      setShowRegenerateButton(true);
      clearInterval(countdownTimerRef.current);
    }, initialTtl * 1000);
  };

  // 📱 NOVA FUNÇÃO PARA GERAR QR CODE MANUALMENTE (PRIMEIRA VEZ)
  const generateQrCodeManually = async () => {
    process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🔄 Usuário solicitou geração manual do QR Code...');
    setUserRequestedQrCode(true);
    setQrCodeFailed(false);
    await fetchQrCode('manual_user_request');
  };

  // 📱 NOVA FUNÇÃO PARA REGENERAR QR CODE VIA API (BACKEND MELHORADO)
  const regenerateQrCodeViaAPI = async (source = 'manual') => {
    process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`🔄 Regenerando QR Code via nova API (${source})...`);

    // Verificar se componente ainda está montado
    if (!isMountedRef.current) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🛑 Componente desmontado, cancelando regeneração');
      return;
    }

    setGeneratingQrCode(true);
    setQrCodeExpired(false);
    setQrCodeFailed(false);
    setShowRegenerateButton(false);

    // Para stuck_retry, mostrar toast informando que está recriando
    if (source === 'stuck_retry') {
      toast.info(t('toasts.reconnecting', 'Reconectando WhatsApp... Isso pode levar alguns segundos.'), {
        autoClose: 15000,
        toastId: 'reconnecting-toast'
      });
    }

    try {
      const response = await renewQrCodeWhatsapp(empresaID);
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('📡 Resposta da regeneração:', response.data);

      // Fechar toast de reconexão
      toast.dismiss('reconnecting-toast');

      if (!isMountedRef.current) return;

      // Verificar se já está conectado
      if (response.data.isConnected) {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('✅ WhatsApp já está conectado após regeneração');
        setIsLoged(true);
        setGeneratingQrCode(false);
        setQrCodeImg('');
        clearQrCodeTimers();
        return;
      }

      // Processar novo QR Code
      if (response.data.qrcode) {
        const data = response.data;
        let qrCodeData = null;

        // Verificar diferentes formatos de resposta
        if (data.qrcode.qr) {
          qrCodeData = data.qrcode.qr;
        } else if (data.qrcode.base64) {
          qrCodeData = data.qrcode.base64;
        } else if (typeof data.qrcode === 'string') {
          qrCodeData = data.qrcode;
        }

        if (qrCodeData && qrCodeData.startsWith('data:image/')) {
          setQrCodeImg(qrCodeData);
          setGeneratingQrCode(false);
          process.env.REACT_APP_ISDEVELOP === 'true' && console.log('✅ QR Code regenerado com sucesso');

          if (source === 'stuck_retry') {
            toast.success(t('toasts.instanceRecreatedSuccess', 'Instância recriada! Escaneie o QR Code abaixo.'), { autoClose: 5000 });
          }

          // Usar TTL do backend se disponível
          const ttl = data.qrcode.ttl ?
            Math.max(1, data.qrcode.ttl - Math.floor(Date.now() / 1000)) : 45;

          startQrCodeTimer(ttl);
          return;
        }
      }

      // Se chegou aqui, algo deu errado
      process.env.REACT_APP_ISDEVELOP === 'true' && console.error('❌ Erro ao processar QR Code regenerado:', response.data);
      throw new Error('QR Code inválido na resposta');

    } catch (error) {
      toast.dismiss('reconnecting-toast');
      process.env.REACT_APP_ISDEVELOP === 'true' && console.error(`❌ Erro ao regenerar QR Code via API (${source}):`, error);

      if (!isMountedRef.current) return;

      // Se veio de stuck_retry, tentar fallback com fetchQrCode (que também faz auto-reset)
      if (source === 'stuck_retry') {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🔄 [STUCK] Tentando via endpoint /qrcode (também faz auto-reset)...');
        toast.info(t('toasts.retrying', 'Tentando método alternativo...'), { autoClose: 5000 });
        try {
          await fetchQrCode('stuck_retry_fallback');
        } catch (fallbackError) {
          process.env.REACT_APP_ISDEVELOP === 'true' && console.error('❌ Fallback também falhou:', fallbackError);
          setGeneratingQrCode(false);
          setQrCodeFailed(true);
          toast.error(t('toasts.reconnectFailed', 'Falha ao reconectar. Tente novamente em alguns segundos.'), { autoClose: 5000 });
        }
        return;
      }

      // Para outros sources, usar fallback normal
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🔄 Tentando fallback com método antigo...');
      await regenerateQrCodeFallback(source);
    }
  };

  // 📱 FUNÇÃO DE FALLBACK PARA REGENERAÇÃO (MÉTODO ANTIGO)
  const regenerateQrCodeFallback = async (source = 'fallback') => {
    process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`🔄 Regenerando QR Code via fallback (${source})...`);

    // Resetar estados
    setQrCodeExpired(false);
    setShowRegenerateButton(false);
    setGeneratingQrCode(true);

    try {
      await fetchQrCode(`fallback_${source}`);
    } catch (error) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.error(`❌ Erro ao regenerar QR Code via fallback (${source}):`, error);
      setGeneratingQrCode(false);
      setShowRegenerateButton(true);
      setQrCodeFailed(true);
    }
  };



  // Função para navegar para o chat no mobile
  const handleSelectChatMobile = (chat) => {
    setSelectedChat(chat);
    if (isMobile) {
      setShowMobileChat(true);
    }

    // **📌 MARCAR MENSAGENS COMO LIDAS AO SELECIONAR CHAT**
    if (unreadCounts[chat._id] && unreadCounts[chat._id] > 0) {
      markChatAsRead(chat._id);
    }
  };

  // Função para voltar para a lista no mobile
  const handleBackToList = () => {
    if (isMobile) {
      setShowMobileChat(false);
      setSelectedChat(null);
    }
  };

  // Função para abrir perfil apenas quando clicar na foto
  const handleOpenProfile = (e) => {
    e.stopPropagation(); // Previne propagação do evento
    setIsProfileOpen(true);
  };





  // **📌 FUNÇÕES DO MENU DE CONTEXTO (BOTÃO DIREITO)**
  const handleRightClick = (e, chat) => {
    e.preventDefault();
    e.stopPropagation();

    setContextMenu({
      visible: true,
      x: e.clientX,
      y: e.clientY,
      chat: chat
    });
  };

  const handleCloseContextMenu = () => {
    setContextMenu({
      visible: false,
      x: 0,
      y: 0,
      chat: null
    });
  };

  const handleDeleteMessages = async () => {
    const chatToDelete = contextMenu.chat;

    if (!chatToDelete) {
      handleCloseContextMenu();
      return;
    }

    // Confirmar antes de deletar
    const confirmed = window.confirm(
      t('confirmations.deleteMessages', { name: chatToDelete.name })
    );

    if (!confirmed) {
      handleCloseContextMenu();
      return;
    }

    try {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`🗑️ Deletando mensagens do lead: ${chatToDelete._id}`);

      await deleteLeadMessages(empresaID, chatToDelete._id, token);

      // Limpar mensagens da conversa atual se for a selecionada
      if (selectedChat && selectedChat._id === chatToDelete._id) {
        setMessagesLeadChannel([]);
      }

      // Limpar cache de mensagens
      setMessagesCache(prevCache => {
        const newCache = new Map(prevCache);
        newCache.delete(chatToDelete._id);
        return newCache;
      });

      toast.success(`✅ ${t('toasts.deleteMessagesSuccess', { name: chatToDelete.name })}`, {
        position: "top-right",
        autoClose: 3000,
      });

      process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`✅ Mensagens deletadas com sucesso do lead: ${chatToDelete._id}`);

    } catch (error) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.error('❌ Erro ao deletar mensagens:', error);
      toast.error(`❌ ${t('toasts.deleteMessagesError')}`, {
        position: "top-right",
        autoClose: 5000,
      });
    }

    handleCloseContextMenu();
  };

  // Fechar menu de contexto ao clicar fora
  useEffect(() => {
    const handleClickOutsideContext = (e) => {
      if (contextMenu.visible) {
        handleCloseContextMenu();
      }
    };

    if (contextMenu.visible) {
      document.addEventListener('click', handleClickOutsideContext);
      document.addEventListener('contextmenu', handleClickOutsideContext);
    }

    return () => {
      document.removeEventListener('click', handleClickOutsideContext);
      document.removeEventListener('contextmenu', handleClickOutsideContext);
    };
  }, [contextMenu.visible]);

  // Resetar estado mobile quando a tela mudar de tamanho
  useEffect(() => {
    if (!isMobile) {
      setShowMobileChat(false);
    }
  }, [isMobile]);



  // Sort messages by date
  const sortedMessages = [...messagesLeadChannel].sort((a, b) =>
    new Date(a.createdAt) - new Date(b.createdAt)
  );

  const groupedMessages = groupMessagesByDate(sortedMessages);
  const messageEndRef = useRef(null);

  useEffect(() => {
    // **📌 SÓ ROLAR PARA O BOTTOM SE NÃO ESTIVER CARREGANDO MENSAGENS ANTIGAS**
    if (messageEndRef.current && !loadingMoreMessages && shouldScrollToBottom) {
      // **📌 GARANTIR SCROLL INSTANTÂNEO PARA O BOTTOM, ESPECIALMENTE QUANDO ABRE CONVERSA**
      const container = messagesContainerRef.current;
      if (container && messagesLeadChannel.length > 0) {
        // Forçar scroll para o bottom imediatamente
        container.scrollTop = container.scrollHeight;

        // Backup com scrollIntoView para garantir
        setTimeout(() => {
          if (messageEndRef.current && shouldScrollToBottom) {
            messageEndRef.current.scrollIntoView({ behavior: "instant" });
          }
        }, 50);
      }
    }
  }, [messagesLeadChannel, loadingMoreMessages, shouldScrollToBottom]);

  const handleClickOutside = event => {
    if (menuRef.current && !menuRef.current.contains(event.target))
      setIsMenuOpen(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!message.trim() || isSubmitting) return;

    if (!selectedChat || !selectedChat.mobile_number) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.error('Nenhum chat selecionado ou número inválido');
      return;
    }



    const messageToSend = message.trim();

    // **📌 ENVIO OTIMISTA: Adicionar mensagem imediatamente**
    const optimisticMessage = {
      _id: `temp_${Date.now()}`,
      text: messageToSend,
      fromMe: true,
      createdAt: new Date().toISOString(),
      messageDate: new Date().toISOString(),
      leadChannel: selectedChat._id,
      isOptimistic: true, // Flag para identificar mensagens otimistas
      status: 'sending'
    };

    // Adicionar mensagem otimista na conversa
    setMessagesLeadChannel(oldMessages => [optimisticMessage, ...oldMessages]);

    // **📌 PARAR LOADING JÁ QUE TEMOS MENSAGEM OTIMISTA**
    setLoadingMessages(false);

    // **📌 GARANTIR QUE O SCROLL PERMANEÇA NO BOTTOM APÓS MENSAGEM OTIMISTA**
    setTimeout(() => {
      const container = messagesContainerRef.current;
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    }, 50);

    // Atualizar cache das mensagens
    setMessagesCache(prevCache => {
      const newCache = new Map(prevCache);
      const cachedMessages = newCache.get(selectedChat._id) || [];
      newCache.set(selectedChat._id, [optimisticMessage, ...cachedMessages]);
      return newCache;
    });

    // Atualizar a lista de chats com a mensagem otimista
    setChats(oldChats => {
      const updatedChats = oldChats.map(chat => {
        if (chat._id === selectedChat._id) {
          return {
            ...chat,
            message: {
              text: messageToSend,
              message: messageToSend,
              messageDate: new Date().toISOString(),
              createdAt: new Date().toISOString(),
              fromMe: true
            },
            updatedAt: new Date().toISOString()
          };
        }
        return chat;
      });

      // Mover o chat atualizado para o topo da lista
      const chatIndex = updatedChats.findIndex(chat => chat._id === selectedChat._id);
      if (chatIndex > 0) {
        const [chatToMove] = updatedChats.splice(chatIndex, 1);
        updatedChats.unshift(chatToMove);
      }

      return updatedChats;
    });

    try {
      setIsSubmitting(true);
      setMessage('');  // Limpa o campo de mensagem antes do envio

      await sendTextMessageWhatsapp(empresaID, selectedChat.mobile_number, messageToSend);

      // Atualizar status da mensagem otimista para 'sent'
      setMessagesLeadChannel(oldMessages =>
        oldMessages.map(msg =>
          msg._id === optimisticMessage._id
            ? { ...msg, status: 'sent' }
            : msg
        )
      );

      // A mensagem real será adicionada automaticamente via webhook quando for processada

    } catch (error) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.error('❌ Erro ao enviar a mensagem:', error);
      process.env.REACT_APP_ISDEVELOP === 'true' && console.error('❌ Detalhes do erro:', error.response?.data);
      process.env.REACT_APP_ISDEVELOP === 'true' && console.error('❌ Status:', error.response?.status);

      // Remover mensagem otimista em caso de erro
      setMessagesLeadChannel(oldMessages =>
        oldMessages.filter(msg => msg._id !== optimisticMessage._id)
      );

      // Remover do cache também
      setMessagesCache(prevCache => {
        const newCache = new Map(prevCache);
        const cachedMessages = newCache.get(selectedChat._id) || [];
        newCache.set(selectedChat._id, cachedMessages.filter(msg => msg._id !== optimisticMessage._id));
        return newCache;
      });

      // Restaurar a mensagem em caso de erro
      setMessage(messageToSend);

      // Mostrar toast de erro com detalhes
      const errorMessage = error.response?.data?.error || t('toasts.sendMessageError');
      toast.error(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };


















  // **📌 CRIAR SOCKET GLOBAL QUE PERSISTE ENTRE NAVEGAÇÕES**
  useEffect(() => {
    const socketNamespace = "/whatsapp";
    const wsUrl = apiUrl.replace(/\/$/, '') + socketNamespace;

    // Verificar se já existe um socket global conectado
    if (window.whatsappSocket && window.whatsappSocket.connected) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log("✅ Reutilizando socket WhatsApp existente");
      setMainSocket(window.whatsappSocket);
      return;
    }

    process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🔌 Criando novo socket WhatsApp global");
    process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🌐 [SOCKET] URL de conexão:", wsUrl);
    process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🔑 [SOCKET] Token presente:", !!getCurrentAccessToken());

    const socket = io(wsUrl, {
      withCredentials: true,
      transports: ['websocket'],
      auth: { token: getCurrentAccessToken() },
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 5000
    });

    process.env.REACT_APP_ISDEVELOP === 'true' && console.log("📡 [SOCKET] Socket criado, aguardando conexão...");

    // Armazenar socket globalmente para reutilização
    window.whatsappSocket = socket;
    setMainSocket(socket);

    return () => {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🛑 Desmontando componente WhatsApp - mantendo socket conectado...");
      // ❌ NÃO DESCONECTAR O SOCKET - apenas limpar listeners específicos
      // O socket deve permanecer conectado para outras telas
      setMainSocket(null);
    };
  }, [apiUrl]);


  // **📌 WAKE FROM SUSPEND: Refresh token + reconnect socket when page becomes visible**
  useEffect(() => {
    let hiddenSince = null;

    const handleVisibilityChange = async () => {
      if (document.hidden) {
        hiddenSince = Date.now();
        return;
      }

      // Page became visible — check if was hidden long enough (>30s)
      const wasHiddenMs = hiddenSince ? (Date.now() - hiddenSince) : 0;
      if (wasHiddenMs < 30000) return; // Skip if hidden < 30s

      console.log(`[WAKE] Page visible after ${Math.round(wasHiddenMs / 1000)}s — refreshing token...`);

      // Wait for network to stabilize after suspend
      await new Promise(r => setTimeout(r, 2000));

      // Refresh token proactively via HttpOnly cookie
      const newToken = await refreshAccessTokenManually();
      if (!newToken) {
        console.warn('[WAKE] Token refresh failed — may need re-login');
        return;
      }

      console.log('[WAKE] Token refreshed successfully');

      // Update socket auth for next reconnection
      if (mainSocket) {
        mainSocket.auth = { token: newToken };
        if (!mainSocket.connected) {
          console.log('[WAKE] Socket disconnected — forcing reconnect with new token');
          mainSocket.connect();
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [mainSocket]);


  // **📌 CONFIGURAR EVENTOS DE CHATS NO SOCKET PRINCIPAL**
  useEffect(() => {
    if (!mainSocket) return;

    // Conectar ao namespace WhatsApp
    mainSocket.on('connect', () => {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log("✅ Socket WhatsApp conectado - ID:", mainSocket.id);
      // **📌 IMPORTANTE: O join na sala é automático no backend quando o socket conecta**
      const roomName = `chats:${empresaID}`;
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`🏠 Socket automaticamente na sala: ${roomName}`);

      // **📌 DEBUG: Verificar se o socket está realmente conectado**
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🔍 [DEBUG SOCKET] Estado da conexão:", {
        connected: mainSocket.connected,
        id: mainSocket.id,
        transport: mainSocket.io.engine.transport.name,
        empresaID: empresaID
      });

      // **📌 FUNÇÃO DE TESTE GLOBAL PARA DEBUG**
      window.testWhatsAppSocket = () => {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🧪 [TESTE SOCKET] Testando conexão WhatsApp...");
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("Socket conectado:", mainSocket.connected);
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("Socket ID:", mainSocket.id);
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("Empresa ID:", empresaID);

        // Emitir evento de teste
        mainSocket.emit('test-connection', { empresaID, timestamp: Date.now() });
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("📤 Evento de teste enviado");
      };
    });

    mainSocket.on('disconnect', (reason) => {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log("❌ Socket WhatsApp desconectado:", reason);
    });

    mainSocket.on('connect_error', (error) => {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.error("🚨 Erro de conexão socket WhatsApp:", error);
    });

    // **📌 WAKE RECOVERY: Update auth token on reconnect (after suspend/network loss)**
    mainSocket.io.on('reconnect', (attemptNumber) => {
      console.log(`[SOCKET] Reconnected after ${attemptNumber} attempt(s) — updating auth token`);
      const freshToken = getCurrentAccessToken();
      if (freshToken) {
        mainSocket.auth = { token: freshToken };
      }
    });

    mainSocket.on('chats', (newChat) => {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log("📨 [SOCKET] Novo chat recebido via socket:", {
        name: newChat.name,
        id: newChat._id,
        hasMessage: !!newChat.message,
        messageText: newChat.message?.text || newChat.message?.message,
        fromMe: newChat.message?.fromMe,
        timestamp: new Date().toISOString()
      });

      setChats(oldChats => {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`🔄 [SOCKET] Atualizando lista de chats - total atual: ${oldChats.length}`);
        // Remove o chat existente se já estiver na lista e adiciona o novo no início
        const filteredChats = oldChats.filter(chat => chat._id !== newChat._id);
        const newChatList = [newChat, ...filteredChats];
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`✅ [SOCKET] Nova lista de chats - total: ${newChatList.length}`);
        return newChatList;
      });

      // **📌 ATUALIZAR CACHE SE A MENSAGEM FOR DE UMA CONVERSA ATIVA**
      if (newChat.message && !newChat.message.fromMe) {
        setMessagesCache(prevCache => {
          const newCache = new Map(prevCache);
          const cachedMessages = newCache.get(newChat._id) || [];

          // Criar objeto de mensagem para o cache
          const messageForCache = {
            _id: newChat.message.id || `msg_${Date.now()}`,
            text: newChat.message.text || newChat.message.message,
            fromMe: newChat.message.fromMe,
            createdAt: newChat.message.createdAt || newChat.message.messageDate,
            messageDate: newChat.message.messageDate || newChat.message.createdAt,
            leadChannel: newChat._id
          };

          // Verificar se a mensagem já existe no cache
          const messageExists = cachedMessages.some(msg =>
            msg.text === messageForCache.text &&
            msg.fromMe === messageForCache.fromMe &&
            Math.abs(new Date(msg.createdAt) - new Date(messageForCache.createdAt)) < 5000 // 5 segundos de tolerância
          );

          if (!messageExists) {
            newCache.set(newChat._id, [messageForCache, ...cachedMessages]);
          }

          return newCache;
        });

        // **📌 ATUALIZAR CONTAGEM DE MENSAGENS NÃO LIDAS EM TEMPO REAL**
        if (!selectedChat || selectedChat._id !== newChat._id) {
          // Se o chat não está selecionado, incrementar contador
          setUnreadCounts(prevCounts => ({
            ...prevCounts,
            [newChat._id]: (prevCounts[newChat._id] || 0) + 1
          }));
        } else {
          // **📌 SE O CHAT ESTÁ ABERTO, MARCAR MENSAGEM COMO LIDA AUTOMATICAMENTE**
          process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`📖 Chat ${newChat.name} está aberto, marcando nova mensagem como lida automaticamente`);
          setTimeout(() => {
            markChatAsRead(newChat._id);
          }, 1000); // Delay de 1 segundo para garantir que a mensagem foi salva no banco
        }
      }

      process.env.REACT_APP_ISDEVELOP === 'true' && console.log("✅ Lista de chats atualizada com nova mensagem de:", newChat.name);
    });

    // 📱 LISTENER MELHORADO PARA QR CODE UPDATES VIA SOCKET - COM FILTRO POR EMPRESA
    mainSocket.on('whatsapp_qrcode_update', (data) => {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('📱 [SOCKET] QR Code atualizado via socket:', {
        instanceId: data.instanceId,
        empresaID: data.empresaID,
        empresaName: data.empresaName,
        hasQrCode: !!data.qrcode,
        renewed: data.renewed,
        timestamp: data.timestamp
      });

      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('📊 [SOCKET] Estado atual:', {
        qrCodeImg: !!qrCodeImg,
        qrCodeExpired,
        generatingQrCode,
        isLoged,
        empresaAtual: empresaID
      });

      // **🎯 FILTRO CRÍTICO: IGNORAR QR CODES DE OUTRAS EMPRESAS**
      if (data.empresaID && data.empresaID !== empresaID) {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`🚫 [SOCKET] QR Code ignorado - empresa diferente! Recebido: ${data.empresaName} (${data.empresaID}), Atual: ${empresaID}`);
        return;
      }

      // 🚫 IGNORAR QR CODES AUTOMÁTICOS SE JÁ ESTAMOS CONECTADOS
      if (isLoged) {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🚫 [SOCKET] Ignorando QR Code - já conectado (isLoged=true)');
        return;
      }

      // 🔧 NOVO: IGNORAR QR CODES SE USUÁRIO NÃO SOLICITOU
      if (!userRequestedQrCode) {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🚫 [SOCKET] Ignorando QR Code - usuário não solicitou geração');
        return;
      }

      if (data.qrcode && data.instanceId) {
        // 🔧 MELHOR VALIDAÇÃO DO QR CODE RECEBIDO VIA SOCKET
        const qrData = data.qrcode;
        let validQrCode = null;

        if (typeof qrData === 'string' && qrData.startsWith('data:image/')) {
          validQrCode = qrData;
        } else if (qrData.qr && typeof qrData.qr === 'string' && qrData.qr.startsWith('data:image/')) {
          validQrCode = qrData.qr;
        } else if (qrData.base64 && typeof qrData.base64 === 'string' && qrData.base64.startsWith('data:image/')) {
          validQrCode = qrData.base64;
        }

        if (validQrCode) {
          process.env.REACT_APP_ISDEVELOP === 'true' && console.log('✅ [SOCKET] QR Code válido recebido via socket');

          // 🕒 Cancelar timer "QR pendente" — o socket entregou antes do timeout
          if (pendingQrTimerRef.current) {
            clearTimeout(pendingQrTimerRef.current);
            pendingQrTimerRef.current = null;
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log('✅ [SOCKET] Timer pendente cancelado — socket entregou QR no prazo');
          }

          setQrCodeImg(validQrCode);
          setQrCodeFailed(false); // Garantir que não fica em estado de falha residual
          setGeneratingQrCode(false);

          // Usar TTL do backend se disponível, senão usar 45 segundos
          let ttl = 45;
          if (qrData.ttl) {
            ttl = Math.max(1, qrData.ttl - Math.floor(Date.now() / 1000));
          }

          // Reiniciar timer com TTL correto
          startQrCodeTimer(ttl);

          // Mostrar toast se foi renovado
          if (data.renewed) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🔄 QR Code renovado automaticamente via socket');
          }
        } else {
          process.env.REACT_APP_ISDEVELOP === 'true' && console.error('❌ [SOCKET] QR Code inválido recebido via socket:', JSON.stringify(qrData, null, 2));
        }
      }
    });

    // 📱 LISTENER MELHORADO PARA CONNECTION UPDATES VIA SOCKET - COM FILTRO POR EMPRESA
    mainSocket.on('whatsapp_connection_update', (data) => {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🔗 [SOCKET] Status de conexão atualizado:', {
        instanceId: data.instanceId,
        empresaID: data.empresaID,
        state: data.state,
        isConnected: data.isConnected,
        statusCode: data.statusCode,
        timestamp: data.timestamp
      });

      // **🎯 FILTRO CRÍTICO: IGNORAR CONNECTION UPDATES DE OUTRAS EMPRESAS**
      if (data.empresaID && data.empresaID !== empresaID) {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`🚫 [SOCKET] Connection update ignorado - empresa diferente! Recebido: ${data.empresaID}, Atual: ${empresaID}`);
        return;
      }

      if (data.isConnected || data.state === 'open') {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('✅ [SOCKET] WhatsApp conectado via connection update!');
        setIsLoged(true);
        setGeneratingQrCode(false);
        setQrCodeImg('');
        clearQrCodeTimers();
      } else if (data.state === 'close' || data.statusCode === 400) {
        // **🔴 TRATAR DESCONEXÃO: Atualizar UI quando WhatsApp desconecta**
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🔴 [SOCKET] WhatsApp desconectado via connection update!', {
          source: data.source,
          message: data.message,
          newInstance: data.newInstance
        });
        setIsLoged(false);
        setGeneratingQrCode(false);
        setQrCodeImg('');
        clearQrCodeTimers();
        setUserRequestedQrCode(false);

        // Se instância foi recriada pelo backend, notificar usuário
        if (data.source === 'instance_recreated') {
          toast.info(
            data.message || t('toasts.instanceRecreated', 'Instância WhatsApp recriada. Escaneie o QR Code para reconectar.'),
            { autoClose: 8000 }
          );
        } else if (data.source === 'health_check') {
          toast.warning(
            t('toasts.connectionLost', 'Conexão WhatsApp perdida. Clique em "Gerar QR Code" para reconectar.'),
            { autoClose: 5000 }
          );
        }
      }
    });

    // 📱 NOVO LISTENER PARA EVENTO DE CONEXÃO ESTABELECIDA - COM FILTRO POR EMPRESA
    mainSocket.on('whatsapp_connected', (data) => {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🎉 [SOCKET] WhatsApp conectado com sucesso!', {
        instanceId: data.instanceId,
        empresaID: data.empresaID,
        message: data.message,
        timestamp: data.timestamp
      });

      // **🎯 FILTRO CRÍTICO: IGNORAR CONEXÕES DE OUTRAS EMPRESAS**
      if (data.empresaID && data.empresaID !== empresaID) {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`🚫 [SOCKET] Conexão ignorada - empresa diferente! Recebido: ${data.empresaID}, Atual: ${empresaID}`);
        return;
      }

      // Limpar cache de foto de perfil quando JID muda (novo número conectado)
      if (data.jidChanged) {
        console.log('🧹 JID mudou - limpando cache de foto de perfil');
        localStorage.removeItem(`my_profile_picture_${empresaID}`);
        localStorage.removeItem(`my_profile_picture_timestamp_${empresaID}`);
        setMyProfilePicture(null);
      }

      // Atualizar interface imediatamente
      setIsLoged(true);
      setGeneratingQrCode(false);
      setQrCodeImg('');
      clearQrCodeTimers();

      // Recarregar chats apenas se não foi o carregamento inicial
      setTimeout(() => {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🔄 Verificando se precisa recarregar chats após conexão...');
        if (!isInitialLoad && chats.length > 0) {
          process.env.REACT_APP_ISDEVELOP === 'true' && console.log('♻️ Recarregando chats após reconexão...');
          setChats([]);
          setPage(0);
          setHasMoreChats(true);
          fetchChats(0, false, 'socket_reconnection');
        } else {
          process.env.REACT_APP_ISDEVELOP === 'true' && console.log('✅ Carregamento inicial ainda em andamento, não duplicando...');
        }
      }, 1000);
    });

    return () => {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🛑 Limpando eventos específicos do componente WhatsApp...");
      // ✅ LIMPEZA ESPECÍFICA - não afetar outros componentes que usam o socket
      if (mainSocket) {
        mainSocket.off('chats');
        mainSocket.off('connect');
        mainSocket.off('disconnect');
        mainSocket.off('connect_error');
        mainSocket.off('reconnect');
        mainSocket.io.off('reconnect'); // Manager-level reconnect handler
        mainSocket.off('whatsapp_qrcode_update');
        mainSocket.off('whatsapp_connection_update');
        mainSocket.off('whatsapp_connected'); // 📱 NOVO EVENTO

        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("✅ Eventos específicos do WhatsApp removidos - socket mantido para outras telas");
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainSocket, empresaID]); // Removido dependências desnecessárias que causam re-montagem do socket

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  });

  useEffect(() => {
    // Defina isMounted como true ao montar o componente
    isMountedRef.current = true;
    cancelQrCodeFetchRef.current = false; // Redefine o cancelamento ao montar o componente

    // **📌 VERIFICAR STATUS REAL DA EVOLUTION API PRIMEIRO**
    process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🚀 Iniciando verificação de status REAL da Evolution API...');

    // Função assíncrona para verificar status e decidir o que fazer
    const initializeWhatsApp = async () => {
      try {
        // Primeiro verificar se realmente está conectado
        const isConnected = await checkConnectionStatus('component_mount');

        if (!isConnected) {
          // Se não estiver conectado, NÃO gerar QR code automaticamente
          process.env.REACT_APP_ISDEVELOP === 'true' && console.log('📱 Não conectado, aguardando comando manual do usuário para gerar QR Code...');
          // 🔧 REMOVIDO: await fetchQrCode('component_mount_disconnected');
        } else {
          process.env.REACT_APP_ISDEVELOP === 'true' && console.log('✅ Já conectado, mantendo interface de chat');
        }
      } catch (error) {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.error('❌ Erro na inicialização do WhatsApp:', error);
        // Em caso de erro, NÃO gerar QR code automaticamente
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('⚠️ Erro na verificação, aguardando comando manual do usuário...');
        // 🔧 REMOVIDO: await fetchQrCode('component_mount_error');
      }
    };

    initializeWhatsApp();

    // Função de limpeza ao desmontar o componente
    return () => {
      isMountedRef.current = false; // Define como false quando o componente desmonta
      cancelQrCodeFetchRef.current = true; // Cancela qualquer execução futura de fetchQrCode
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🛑 Timeout cleared on unmount');
      }
      // **📌 LIMPAR TIMER DE CONVERSA RECÉM ABERTA**
      if (justOpenedTimerRef.current) {
        clearTimeout(justOpenedTimerRef.current);
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🛑 justOpenedTimer cleared on unmount');
      }
      // 📱 Limpar timers do QR Code
      clearQrCodeTimers();
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🛑 QR Code timers cleared on unmount');
    };
  }, [checkConnectionStatus]);



  useEffect(() => {
    if (selectedChat?._id) {
      getBotStatusLead(selectedChat._id)
        .then(response => {
          process.env.REACT_APP_ISDEVELOP === 'true' && console.log("Status desse bot:", response.data.bot_pausado)
          setBotPausado(response.data.bot_pausado);
        })
        .catch(error => {
          process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Erro ao obter status do bot:", error);
        });

      // Buscar imagem de perfil quando um chat é selecionado
      fetchProfilePicture(selectedChat);
    }
  }, [selectedChat, fetchProfilePicture]);



  // **📌 FUNÇÃO PARA DETECTAR CONTATOS COM NOMES GENÉRICOS**
  const hasGenericName = (contactName, mobileNumber) => {
    if (!contactName || !mobileNumber) return false;

    // Verificar se o nome é genérico
    const cleanName = contactName.trim();
    const cleanNumber = mobileNumber.toString();
    const lowerName = cleanName.toLowerCase();

    // Lista de nomes genéricos que indicam falta de informação real
    const genericWords = ['você', 'voce', 'tu', 'you', 'me', 'eu', 'cliente'];

    const genericPatterns = [
      cleanName === cleanNumber, // Nome igual ao número
      cleanName.startsWith('Contato '), // Nome começa com "Contato "
      /^\d{10,}$/.test(cleanName), // Nome é só números (10+ dígitos)
      cleanName === `Contato ${cleanNumber}`, // Formato exato "Contato 556299999"
      cleanName.length < 3, // Nomes muito curtos provavelmente são genéricos
      /^[+\-()s\d]+$/.test(cleanName), // Nome contém apenas números e símbolos telefônicos
      genericWords.includes(lowerName) // Nome é uma palavra genérica (Você, Cliente, etc.)
    ];

    return genericPatterns.some(pattern => pattern);
  };



  // **📌 FUNÇÃO PARA ATUALIZAR INFORMAÇÕES DE UM CONTATO ESPECÍFICO**
  const refreshContactInfo = async (chatId, chatName) => {
    if (refreshingContact) return; // Evitar múltiplas chamadas simultâneas

    setRefreshingContact(true);
    try {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`🔄 Atualizando informações do contato ${chatName}...`);
      const response = await refreshContactInfoWhatsapp(chatId, token);

      if (response.data && response.data.status === 200) {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`✅ Informações atualizadas:`, response.data);

        // Atualizar o chat na lista local se houve mudança
        if (response.data.contactName !== response.data.oldName || response.data.profilePictureUpdated) {
          setChats(prevChats =>
            prevChats.map(c =>
              c._id === chatId
                ? {
                  ...c,
                  name: response.data.contactName,
                  channel_data: {
                    ...c.channel_data,
                    whatsapp: {
                      ...c.channel_data?.whatsapp,
                      profile_picture: response.data.profilePictureUrl || c.channel_data?.whatsapp?.profile_picture,
                      profile_picture_updateAt: response.data.profilePictureUpdated ? new Date().toISOString() : c.channel_data?.whatsapp?.profile_picture_updateAt,
                      pushName: response.data.contactName
                    }
                  }
                }
                : c
            )
          );

          // Se é o chat selecionado, atualizar também
          if (selectedChat && selectedChat._id === chatId) {
            setSelectedChat(prev => ({
              ...prev,
              name: response.data.contactName,
              channel_data: {
                ...prev.channel_data,
                whatsapp: {
                  ...prev.channel_data?.whatsapp,
                  profile_picture: response.data.profilePictureUrl || prev.channel_data?.whatsapp?.profile_picture,
                  profile_picture_updateAt: response.data.profilePictureUpdated ? new Date().toISOString() : prev.channel_data?.whatsapp?.profile_picture_updateAt,
                  pushName: response.data.contactName
                }
              }
            }));
          }
        }

        // Mostrar toast de sucesso
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } catch (error) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.error(`❌ Erro ao atualizar informações do contato ${chatName}:`, error);
      toast.error(t('toasts.updateContactError'), {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      setRefreshingContact(false);
    }
  };

  // **📌 FUNÇÃO PARA BUSCAR MINHA IMAGEM DE PERFIL (PRÓPRIO USUÁRIO)**
  const fetchMyProfilePicture = useCallback(async (forceUpdate = false) => {
    // **📌 VERIFICAR CACHE LOCAL PRIMEIRO**
    const cachedImage = localStorage.getItem(`my_profile_picture_${empresaID}`);
    const cachedTimestamp = localStorage.getItem(`my_profile_picture_timestamp_${empresaID}`);

    if (!forceUpdate && cachedImage && cachedTimestamp) {
      const cacheAge = new Date() - new Date(cachedTimestamp);
      const cacheValidityDays = 7;

      if (cacheAge < cacheValidityDays * 24 * 60 * 60 * 1000) {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`✅ Minha imagem de perfil já existe no cache local (válida por ${cacheValidityDays} dias)`);
        setMyProfilePicture(cachedImage);
        return;
      }
    }

    try {
      const response = await getMyWhatsappProfilePicture(empresaID, token);

      if (response.data && response.data.status === 200 && response.data.profilePictureUrl) {

        // Salvar no estado e no cache local
        setMyProfilePicture(response.data.profilePictureUrl);
        localStorage.setItem(`my_profile_picture_${empresaID}`, response.data.profilePictureUrl);
        localStorage.setItem(`my_profile_picture_timestamp_${empresaID}`, new Date().toISOString());

      } else {
        setMyProfilePicture(null);
        // Limpar cache se não há imagem
        localStorage.removeItem(`my_profile_picture_${empresaID}`);
        localStorage.removeItem(`my_profile_picture_timestamp_${empresaID}`);
      }
    } catch (error) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.error(`❌ Erro ao buscar minha imagem de perfil:`, error);

      // **🔧 RECUPERAÇÃO AUTOMÁTICA: Se erro for por falta de JID, tentar buscar JID automaticamente**
      if (error.response?.data?.error?.includes?.('JID do WhatsApp não encontrado')) {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`🔄 JID não encontrado. Tentando buscar e salvar JID automaticamente...`);

        try {
          const { fetchWhatsappJID } = await import('../../services/api');
          const jidResponse = await fetchWhatsappJID(empresaID, token);

          if (jidResponse.data?.status === 200) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`✅ JID recuperado com sucesso: ${jidResponse.data.jid}`);
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`🔄 Tentando buscar foto de perfil novamente...`);

            // Tentar buscar a foto de perfil novamente agora que o JID foi salvo
            const retryResponse = await getMyWhatsappProfilePicture(empresaID, token);

            if (retryResponse.data?.status === 200 && retryResponse.data.profilePictureUrl) {
              setMyProfilePicture(retryResponse.data.profilePictureUrl);
              localStorage.setItem(`my_profile_picture_${empresaID}`, retryResponse.data.profilePictureUrl);
              localStorage.setItem(`my_profile_picture_timestamp_${empresaID}`, new Date().toISOString());
              process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`🎉 Foto de perfil carregada com sucesso após recuperar JID!`);
              return;
            }
          } else {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`⚠️ Não foi possível recuperar o JID:`, jidResponse.data);
          }
        } catch (jidError) {
          process.env.REACT_APP_ISDEVELOP === 'true' && console.error(`❌ Erro ao tentar recuperar JID:`, jidError);
        }
      }

      setMyProfilePicture(null);
      // Limpar cache antigo quando falha ao buscar foto (ex: 403 por privacidade do novo número)
      localStorage.removeItem(`my_profile_picture_${empresaID}`);
      localStorage.removeItem(`my_profile_picture_timestamp_${empresaID}`);
    }
  }, [empresaID, token]);

  // **📌 FUNÇÃO PARA CARREGAR MAIS MENSAGENS (PAGINAÇÃO)**
  const loadMoreMessages = async () => {
    if (!selectedChat || !hasMoreMessages || loadingMoreMessages) {
      return;
    }

    setLoadingMoreMessages(true);
    setShouldScrollToBottom(false); // **📌 NÃO ROLAR PARA O BOTTOM DURANTE PAGINAÇÃO**

    try {
      const nextPage = messagesPage + 1;
      const pageSize = 30;

      const response = await getWhatsappChatLead(empresaID, selectedChat._id, nextPage, pageSize, token);

      if (response.data && response.data.messages && response.data.messages[0] && response.data.messages[0].data) {
        const newMessages = response.data.messages[0].data;
        const totalCount = response.data.messages[0].metadata[0]?.totalCount || 0;

        if (newMessages.length === 0) {
          setHasMoreMessages(false);
        } else {
          // Adicionar novas mensagens ao início da lista (mensagens mais antigas)
          setMessagesLeadChannel(prevMessages => {
            // Evitar duplicatas
            const existingIds = new Set(prevMessages.map(msg => msg._id));
            const uniqueNewMessages = newMessages.filter(msg => !existingIds.has(msg._id));

            // Adicionar mensagens mais antigas no início
            return [...uniqueNewMessages, ...prevMessages];
          });

          // Atualizar cache
          const cacheKey = selectedChat._id;
          setMessagesCache(prevCache => {
            const newCache = new Map(prevCache);
            const existingMessages = newCache.get(cacheKey) || [];

            const existingIds = new Set(existingMessages.map(msg => msg._id));
            const uniqueNewMessages = newMessages.filter(msg => !existingIds.has(msg._id));

            const finalCacheMessages = [...uniqueNewMessages, ...existingMessages];

            newCache.set(cacheKey, finalCacheMessages);
            return newCache;
          });

          setMessagesPage(nextPage);

          // **📌 VERIFICAR SE AINDA HÁ MAIS MENSAGENS USANDO CALLBACK**
          setMessagesLeadChannel(currentMessages => {
            const currentTotal = currentMessages.length;

            if (currentTotal >= totalCount) {
              setHasMoreMessages(false);
            }

            return currentMessages; // Não modificar, apenas verificar
          });
        }
      } else {
        setHasMoreMessages(false);
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`⚠️ Resposta inválida ao carregar mais mensagens para ${selectedChat.name}`);
      }
    } catch (error) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.error(`❌ Erro ao carregar mais mensagens para ${selectedChat.name}:`, error);
    } finally {
      setLoadingMoreMessages(false);
      // **📌 NÃO reativar scroll para bottom após carregar mensagens antigas**
      // O scroll deve permanecer na posição atual (restaurada pelo handleMessagesScroll)
    }
  };

  // **📌 HANDLER PARA SCROLL DAS MENSAGENS (CARREGAR MAIS AO ROLAR PARA CIMA)**
  const handleMessagesScroll = (e) => {
    const container = e.target;
    const scrollTop = container.scrollTop;
    const scrollThreshold = 100; // Pixels do topo para disparar carregamento

    // **📌 NÃO CARREGAR MENSAGENS SE ACABOU DE ABRIR A CONVERSA**
    if (justOpenedChat) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`🚫 Conversa acabou de abrir, ignorando scroll no topo para ${selectedChat?.name}`);
      return;
    }

    // **📌 IGNORAR SCROLL AUTOMÁTICO DURANTE CARREGAMENTO**
    if (loadingMessages) {
      return;
    }

    // Se rolou próximo ao topo e há mais mensagens para carregar
    if (scrollTop <= scrollThreshold && hasMoreMessages && !loadingMoreMessages) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`📜 Scroll detectado no topo - carregando mais mensagens para ${selectedChat?.name}`);

      // **📌 SALVAR POSIÇÃO ATUAL DO SCROLL PARA RESTAURAR APÓS CARREGAR**
      const currentScrollHeight = container.scrollHeight;
      const currentScrollTop = scrollTop;

      loadMoreMessages().then(() => {
        // **📌 RESTAURAR POSIÇÃO DO SCROLL DE FORMA MAIS ROBUSTA**
        const restoreScroll = () => {
          const newScrollHeight = container.scrollHeight;
          const scrollDifference = newScrollHeight - currentScrollHeight;
          const newScrollTop = currentScrollTop + scrollDifference;

          // **📌 APLICAR NOVA POSIÇÃO IMEDIATAMENTE**
          container.scrollTop = newScrollTop;

          // **📌 VERIFICAR SE A POSIÇÃO FOI APLICADA CORRETAMENTE**
          requestAnimationFrame(() => {
            if (Math.abs(container.scrollTop - newScrollTop) > 5) {
              container.scrollTop = newScrollTop;
            }
          });
        };

        // **📌 TENTAR RESTAURAR IMEDIATAMENTE E DEPOIS COM DELAY**
        restoreScroll();
        setTimeout(restoreScroll, 50); // Backup caso o primeiro não funcione
      });
    }
  };


  // **📌 Detectar scroll e carregar mais chats**
  const handleScroll = useCallback(() => {
    if (!hasMoreChats || loadingMore) return;

    const container = chatsContainerRef.current;
    if (!container) return;

    const bottom = container.scrollHeight - container.scrollTop <= container.clientHeight + 10;
    if (bottom) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log("📢 Rolou até o fim, carregando mais chats...");
      setLoadingMore(true);
      setPage((prevPage) => {
        const nextPage = prevPage + 1;
        fetchChats(nextPage, true, 'pagination');
        return nextPage;
      });
    }
  }, [hasMoreChats, loadingMore, fetchChats]);






  const formatDate = (date) => {
    const now = nowTz();
    const inputDate = toTz(date);

    if (now.isSame(inputDate, 'day')) {
      return inputDate.format('HH:mm');
    } else if (now.subtract(1, 'days').isSame(inputDate, 'day')) {
      return t('dates.yesterday');
    } else if (now.subtract(6, 'days').isBefore(inputDate)) {
      return inputDate.format('dddd');
    } else {
      return inputDate.format(i18n.language === 'en-US' ? 'MM/DD/YYYY' : 'DD/MM/YYYY');
    }
  };


  const handleDisconnect = async () => {
    try {
      const res = await removeWhatsappSession(empresaID); // Aguarda a resposta da API

      // Exibe um toast de sucesso com a mensagem da resposta da API
      toast(res.data.msg, {
        autoClose: 3000,
        type: "success"
      });

      // 🔧 REMOVIDO: geração automática de QR Code após desconexão
      // Agora o usuário deve clicar manualmente para gerar
      setUserRequestedQrCode(false); // Resetar flag para exibir botão de geração
      setQrCodeImg(''); // Limpar QR Code atual
      setIsLoged(false); // Marcar como desconectado
      // fetchQrCode(); // REMOVIDO
    } catch (error) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Erro ao encerrar sessão:", error.response?.data || error.message);

      // Exibe um toast de erro com a mensagem da API ou um fallback padrão
      toast(error.response?.data?.msg || t('toasts.disconnectError'), {
        autoClose: 3000,
        type: "error"
      });
    }
  };

  const handleToggleBot = async (lead_id) => {
    try {
      const response = await toggleBotStatus(lead_id);
      setBotPausado(response.data.bot_pausado);
      toast(response.data.msg, {
        autoClose: 3000,
        type: "success"
      });
    } catch (error) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Erro ao alternar o status do bot:", error);
    }
  };


  // **📌 Carregar os chats ao iniciar e ao buscar**
  useEffect(() => {
    process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🚀 useEffect disparado - searchQuery:", searchQuery);
    process.env.REACT_APP_ISDEVELOP === 'true' && console.log("📊 Estado atual - empresaID:", empresaID, "token:", token ? "presente" : "ausente");

    if (!empresaID || !token) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log("⚠️ EmpresaID ou token não disponível, pulando carregamento");
      return;
    }

    setChats([]); // Resetar chats ao buscar
    setPage(0);
    setHasMoreChats(true);
    fetchingChatsRef.current = false; // Reset da flag de controle

    const source = searchQuery ? 'search' : 'initial_load';
    process.env.REACT_APP_ISDEVELOP === 'true' && console.log("📞 Chamando fetchChats(0, false) -", source);
    fetchChats(0, false, source);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery, empresaID, token]); // Removido fetchChats das dependências

  // **📌 Resetar pré-carregamento quando empresa ou token mudar**
  useEffect(() => {
    setHasPreloaded(false);
    setMessagesCache(new Map());
    setPreloadingChats(false);
    setPreloadProgress({ current: 0, total: 0 });
    setRaceConditionsFixed(0);
    setIsInitialLoad(true); // Reset para nova empresa
    fetchingChatsRef.current = false; // Reset da flag de controle

    // **📌 BUSCAR MINHA IMAGEM DE PERFIL QUANDO EMPRESA/TOKEN MUDAR**
    if (empresaID && token) {
      fetchMyProfilePicture();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [empresaID, token]); // Removido fetchMyProfilePicture das dependências

  // **📌 ATUALIZAÇÃO PERIÓDICA DAS CONTAGENS DE MENSAGENS NÃO LIDAS (OTIMIZADA)**
  useEffect(() => {
    if (!empresaID || !token) return;

    // Atualizar contagens a cada 2 minutos (ao invés de 30 segundos)
    const interval = setInterval(() => {
      fetchUnreadCounts();
    }, 120000); // 2 minutos

    return () => clearInterval(interval);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [empresaID, token]); // Removido fetchUnreadCounts das dependências



  // **📌 MONITORAMENTO INTELIGENTE DE STATUS E AUTO-RENOVAÇÃO (COM BACKOFF)**
  useEffect(() => {
    if (!empresaID || !token || isLoged) return;

    let monitoringTimeout = null;
    let connectingCount = 0; // Contador de vezes consecutivas em 'connecting'

    const scheduleNextCheck = () => {
      if (isLoged || !isMountedRef.current) return;

      // 🔧 BACKOFF: Se fica em 'connecting' por muito tempo, reduzir frequência
      let interval = 10000; // 10s padrão
      if (connectingCount > 12) {
        interval = 60000; // Após 2min em 'connecting': checar a cada 60s
      } else if (connectingCount > 6) {
        interval = 30000; // Após 1min em 'connecting': checar a cada 30s
      }

      monitoringTimeout = setTimeout(async () => {
        if (isLoged || !isMountedRef.current) return;

        try {
          const isConnected = await checkConnectionStatus('monitoring');

          if (isConnected) {
            connectingCount = 0;
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log('📊 Monitoramento detectou conexão estabelecida');
            return; // Para de monitorar
          }

          // Incrementar contador se continua em 'connecting'
          connectingCount++;
          if (connectingCount === 6) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log('⚠️ Instância presa em connecting por >1min, reduzindo frequência de polling');
          }
        } catch (error) {
          process.env.REACT_APP_ISDEVELOP === 'true' && console.debug('Erro silencioso no monitoramento:', error.message);
        }

        // Agendar próxima verificação
        scheduleNextCheck();
      }, interval);
    };

    // Iniciar monitoramento após 30 segundos (dar tempo para conexão inicial)
    const startTimer = setTimeout(() => {
      if (!isLoged && isMountedRef.current) {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('📊 Iniciando monitoramento de status inteligente');
        scheduleNextCheck();
      }
    }, 30000);

    return () => {
      clearTimeout(startTimer);
      if (monitoringTimeout) {
        clearTimeout(monitoringTimeout);
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [empresaID, token, isLoged]); // Removido checkConnectionStatus das dependências

  // **📌 Mostrar estatísticas de race conditions evitadas**
  useEffect(() => {
    if (raceConditionsFixed > 0 && raceConditionsFixed % 10 === 0) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`🛡️ Race Conditions evitadas: ${raceConditionsFixed}`);
      toast.success(`🛡️ ${t('toasts.antiBugWorking', { count: raceConditionsFixed })}`, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  }, [raceConditionsFixed]);

  // **📌 Adicionar listener de scroll**
  useEffect(() => {
    const container = chatsContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasMoreChats, loadingMore]); // Removido handleScroll das dependências

  // **📌 GERENCIAR MENSAGENS DO CHAT SELECIONADO (USANDO SOCKET PRINCIPAL)**

  // **📌 GERENCIAR MENSAGENS DO CHAT SELECIONADO (COM DEBOUNCE PARA FETCH)**
  useEffect(() => {
    if (!mainSocket || !selectedChat) {
      return;
    }

    // **📌 CONTROLE DE REQUISIÇÕES ATIVAS PARA EVITAR RACE CONDITIONS**
    let isCurrentConversation = true;
    const currentChatId = selectedChat._id;
    const currentChatName = selectedChat.name;

    // **📌 LIMPAR MENSAGENS E INICIAR LOADING IMEDIATAMENTE AO TROCAR CONVERSA**
    setMessagesLeadChannel([]);
    setLoadingMessages(true);
    setShouldScrollToBottom(true); // **📌 REATIVAR SCROLL PARA O BOTTOM EM NOVA CONVERSA**

    // **📌 MARCAR QUE ACABOU DE ABRIR UMA CONVERSA**
    setJustOpenedChat(true);
    if (justOpenedTimerRef.current) {
      clearTimeout(justOpenedTimerRef.current);
    }

    // **📌 LIMPAR FLAG APÓS 3 SEGUNDOS PARA PERMITIR CARREGAMENTO DE MENSAGENS ANTIGAS**
    justOpenedTimerRef.current = setTimeout(() => {
      setJustOpenedChat(false);
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`✅ Conversa ${currentChatName} liberada para carregamento de mensagens antigas após 3s`);
    }, 3000);

    // **📌 ENTRAR NA SALA DE MENSAGENS ESPECÍFICA DO LEAD (imediato, sem debounce)**
    mainSocket.emit('join-lead-messages', { leadID: currentChatId });

    // **📌 RE-JOIN NA SALA APÓS RECONEXÃO DO SOCKET**
    // Quando o socket reconecta, as salas server-side são perdidas.
    // A sala chats:empresaID é re-joined automaticamente no backend (connection handler),
    // mas messages:leadID precisa ser re-joined manualmente pelo cliente.
    const handleReconnect = () => {
      if (isCurrentConversation) {
        console.log(`🔄 [SOCKET] Reconectado - re-joining sala messages:${currentChatId}`);
        mainSocket.emit('join-lead-messages', { leadID: currentChatId });
      }
    };
    mainSocket.on('connect', handleReconnect);

    // **📌 HANDLER DE MENSAGENS - Função nomeada para cleanup correto**
    const handleNewMessage = (newMessage) => {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log("💬 [SOCKET] Nova mensagem recebida via socket:", {
        text: newMessage.text,
        fromMe: newMessage.fromMe,
        leadChannel: newMessage.leadChannel,
        currentChatId: currentChatId,
        isCurrentConversation: isCurrentConversation,
        timestamp: new Date().toISOString()
      });

      // **📌 VERIFICAR SE O HANDLER AINDA É VÁLIDO (conversa não mudou)**
      if (!isCurrentConversation) {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🚫 [SOCKET] Mensagem ignorada - handler inativo (conversa mudou)");
        return;
      }

      // **📌 VERIFICAR SE A MENSAGEM PERTENCE A ESTA CONVERSA**
      if (newMessage.leadChannel && newMessage.leadChannel !== currentChatId) {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🚫 [SOCKET] Mensagem ignorada - leadChannel não corresponde ao chat atual", {
          messageLeadChannel: newMessage.leadChannel,
          currentChatId: currentChatId
        });
        return;
      }

      // **📌 PARAR LOADING SE ESTIVER ATIVO**
      setLoadingMessages(false);

      // 🔧 DEDUPLICAÇÃO ROBUSTA - Remover mensagens duplicadas e otimistas
      setMessagesLeadChannel(oldMessages => {
        // Verificar se já existe mensagem idêntica (evitar duplicatas)
        const isDuplicate = oldMessages.some(msg =>
          msg._id === newMessage._id ||
          msg.whatsapp_message_id === newMessage.whatsapp_message_id ||
          (msg.id_message && msg.id_message === newMessage.id_message) ||
          // Mensagem otimista ou do bot com mesmo texto
          ((msg.isOptimistic || msg._id?.startsWith?.('bot_')) &&
            msg.text === newMessage.text &&
            msg.fromMe === newMessage.fromMe &&
            Math.abs(new Date(msg.createdAt) - new Date(newMessage.createdAt)) < 5000) // 5 segundos
        );

        if (isDuplicate) {
          process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🔄 [SOCKET] Mensagem duplicada ignorada:", newMessage._id);
          return oldMessages;
        }

        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("✅ [SOCKET] Adicionando nova mensagem ao chat:", newMessage._id);

        // Filtrar mensagens otimistas/bot que agora têm a mensagem real
        const filteredMessages = oldMessages.filter(message => {
          // Remover mensagens otimistas se a mensagem real chegou
          if ((message.isOptimistic || message._id?.startsWith?.('bot_')) &&
              message.text === newMessage.text &&
              message.fromMe === newMessage.fromMe) {
            return false;
          }
          return true;
        });

        return [newMessage, ...filteredMessages];
      });

      // **📌 ATUALIZAR CACHE COM NOVA MENSAGEM (mesma lógica de deduplicação)
      setMessagesCache(prevCache => {
        const newCache = new Map(prevCache);
        const cachedMessages = newCache.get(currentChatId) || [];

        // Verificar duplicata no cache
        const isDuplicateInCache = cachedMessages.some(msg =>
          msg._id === newMessage._id ||
          msg.whatsapp_message_id === newMessage.whatsapp_message_id ||
          (msg.id_message && msg.id_message === newMessage.id_message)
        );

        if (isDuplicateInCache) {
          return prevCache; // Não atualizar cache se for duplicata
        }

        // Filtrar mensagens otimistas/bot que agora têm a mensagem real
        const filteredCachedMessages = cachedMessages.filter(message => {
          if ((message.isOptimistic || message._id?.startsWith?.('bot_')) &&
              message.text === newMessage.text &&
              message.fromMe === newMessage.fromMe) {
            return false;
          }
          return true;
        });

        newCache.set(currentChatId, [newMessage, ...filteredCachedMessages]);
        return newCache;
      });

      // **📌 MARCAR MENSAGEM COMO LIDA SE NÃO FOR MINHA E O CHAT ESTIVER ABERTO**
      if (!newMessage.fromMe) {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`📖 Nova mensagem recebida no chat aberto, marcando como lida automaticamente`);
        setTimeout(() => {
          markChatAsRead(currentChatId);
        }, 1500); // Delay maior para garantir que a mensagem foi processada no backend
      }

      // **📌 GARANTIR QUE O SCROLL PERMANEÇA NO BOTTOM APÓS NOVA MENSAGEM**
      setTimeout(() => {
        const container = messagesContainerRef.current;
        if (container && shouldScrollToBottom) {
          container.scrollTop = container.scrollHeight;
        }
      }, 100);
    };

    // **📌 REGISTRAR HANDLER DE MENSAGENS (imediato, sem debounce)**
    mainSocket.on('messages', handleNewMessage);

    // **📌 FETCH COM DEBOUNCE - Carregar mensagens do servidor após estabilizar seleção**
    const fetchChatLead = async () => {
      // **📌 VERIFICAR SE AINDA É A CONVERSA ATIVA**
      if (!isCurrentConversation) {
        setRaceConditionsFixed(prev => prev + 1);
        return;
      }

      try {
        // **📌 VERIFICAR CACHE PRIMEIRO**
        const cachedMessages = messagesCache.get(currentChatId);
        if (cachedMessages && cachedMessages.length > 0) {

          // **📌 VERIFICAR NOVAMENTE SE AINDA É A CONVERSA ATIVA ANTES DE APLICAR**
          if (isCurrentConversation) {
            setMessagesLeadChannel(cachedMessages);

            // **📌 RESETAR ESTADOS DE PAGINAÇÃO PARA CACHE**
            setMessagesPage(0);
            setHasMoreMessages(cachedMessages.length >= 30);

            setLoadingMessages(false);

            // **📌 FORÇAR SCROLL PARA BOTTOM IMEDIATAMENTE APÓS CARREGAR CACHE**
            setTimeout(() => {
              const container = messagesContainerRef.current;
              if (container && cachedMessages.length > 0) {
                container.scrollTop = container.scrollHeight;
              }
            }, 100);
          } else {
            setRaceConditionsFixed(prev => prev + 1);
          }

          return; // Usar cache, não faz requisição adicional
        }

        // **📌 INICIAR LOADING SE NÃO TIVER CACHE**
        if (isCurrentConversation) {
          setLoadingMessages(true);
        }

        const page = 0;
        const pageSize = 30;

        const response = await getWhatsappChatLead(empresaID, currentChatId, page, pageSize, token);

        // **📌 VERIFICAR SE AINDA É A CONVERSA ATIVA ANTES DE APLICAR RESULTADOS**
        if (!isCurrentConversation) {
          setRaceConditionsFixed(prev => prev + 1);
          return;
        }

        if (response.data && response.data.messages && response.data.messages[0] && response.data.messages[0].data) {
          const messages = response.data.messages[0].data;

          if (isCurrentConversation) {
            setMessagesLeadChannel(messages);

            // **📌 RESETAR ESTADOS DE PAGINAÇÃO PARA NOVA CONVERSA**
            const totalCount = response.data.messages[0].metadata[0]?.totalCount || messages.length;
            setMessagesPage(0);
            setHasMoreMessages(messages.length < totalCount);

            // **📌 ARMAZENAR NO CACHE**
            setMessagesCache(prevCache => {
              const newCache = new Map(prevCache);
              newCache.set(currentChatId, messages);
              return newCache;
            });

            // **📌 FORÇAR SCROLL PARA BOTTOM IMEDIATAMENTE APÓS CARREGAR DA API**
            setTimeout(() => {
              const container = messagesContainerRef.current;
              if (container && messages.length > 0) {
                container.scrollTop = container.scrollHeight;
              }
            }, 100);
          }
        } else {
          if (isCurrentConversation) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`📭 Aplicando array vazio para conversa ativa: ${currentChatName}`);
            setMessagesLeadChannel([]);
            setMessagesPage(0);
            setHasMoreMessages(false);

            setMessagesCache(prevCache => {
              const newCache = new Map(prevCache);
              newCache.set(currentChatId, []);
              return newCache;
            });
          }
        }
      } catch (err) {
        if (!isCurrentConversation) {
          process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`⏹️ Requisição cancelada para ${currentChatName}`);
        } else {
          process.env.REACT_APP_ISDEVELOP === 'true' && console.error(`❌ Erro ao carregar mensagens para ${currentChatName}:`, err);

          if (isCurrentConversation) {
            setMessagesLeadChannel([]);
          }
        }
      } finally {
        if (isCurrentConversation) {
          setLoadingMessages(false);
        }
      }
    };

    // **📌 DEBOUNCE APENAS PARA O FETCH (evita múltiplas requisições em trocas rápidas)**
    const debounceTimer = setTimeout(() => {
      fetchChatLead();
    }, 300);

    // **📌 TIMEOUT PARA FORÇAR PARADA DO LOADING EM CASO DE DEMORA**
    const loadingTimeout = setTimeout(() => {
      if (isCurrentConversation) {
        setLoadingMessages(false);
      }
    }, 10000); // 10 segundos

    // **📌 CLEANUP CORRETO - Executado pelo React ao desmontar ou trocar dependências**
    return () => {
      // Marcar conversa como inativa para cancelar requisições pendentes
      isCurrentConversation = false;

      // Limpar timers
      clearTimeout(debounceTimer);
      clearTimeout(loadingTimeout);
      if (justOpenedTimerRef.current) {
        clearTimeout(justOpenedTimerRef.current);
      }
      setJustOpenedChat(false);

      // **📌 REMOVER HANDLERS ESPECÍFICOS (não afeta outros listeners)**
      mainSocket.off('messages', handleNewMessage);
      mainSocket.off('connect', handleReconnect);

      // **📌 SAIR DA SALA DE MENSAGENS DO LEAD**
      mainSocket.emit('leave-lead-messages', { leadID: currentChatId });

      process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`🔌 [SOCKET] Cleanup: handlers removidos e sala ${currentChatId} abandonada`);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedChat, mainSocket]); // Removido dependências desnecessárias que causam re-renders







  // **📌 FUNÇÃO ROBUSTA PARA ABRIR/CRIAR CONVERSA COM DADOS DO PEDIDO**
  const abrirOuCriarConversa = useCallback(async (dadosPedido) => {
    process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🎯 [ABRIR CONVERSA] Dados recebidos:', dadosPedido);

    // **🔧 VERIFICAR SE JÁ PROCESSOU ESTA COMBINAÇÃO ANTES**
    const conversationKey = dadosPedido ? `${dadosPedido.nome}-${dadosPedido.celular}` : null;
    if (conversationKey && processedLocationRef.current === conversationKey) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('⚠️ [ABRIR CONVERSA] Esta conversa já foi processada antes, ignorando...');
      return;
    }

    // **🔧 EVITAR MÚLTIPLAS EXECUÇÕES PARALELAS**
    if (isCreatingConversation) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('⚠️ [ABRIR CONVERSA] Já existe uma execução em andamento');
      return;
    }

    if (!dadosPedido || !dadosPedido.nome || !dadosPedido.celular) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('❌ [ABRIR CONVERSA] Dados insuficientes');
      showErrorToast(`❌ ${t('toasts.insufficientData')}`);
      return;
    }

    setIsCreatingConversation(true);

    // **🔧 MARCAR COMO PROCESSADO IMEDIATAMENTE**
    processedLocationRef.current = conversationKey;

    // **ESTRATÉGIA 1: Busca robusta por número (múltiplas variações)**
    const cc = getCountryCodeDigits();
    const numeroOriginal = dadosPedido.celular.replace(/\D/g, '');
    const numeroComCodigo = numeroOriginal.startsWith(cc) ? numeroOriginal : `${cc}${numeroOriginal}`;
    const numeroSemCodigo = numeroOriginal.startsWith(cc) ? numeroOriginal.substring(cc.length) : numeroOriginal;

    // Variações com e sem nono dígito
    const numeroSemNono = numeroSemCodigo.length === 11 ?
      numeroSemCodigo.substring(0, 2) + numeroSemCodigo.substring(3) : numeroSemCodigo;
    const numeroComNono = numeroSemCodigo.length === 10 ?
      numeroSemCodigo.substring(0, 2) + '9' + numeroSemCodigo.substring(2) : numeroSemCodigo;

    const variacoesNumero = [
      numeroOriginal,
      numeroComCodigo,
      numeroSemCodigo,
      `${cc}${numeroSemNono}`,
      `${cc}${numeroComNono}`,
      numeroSemNono,
      numeroComNono
    ];

    process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🔍 [ABRIR CONVERSA] Buscando por variações:', variacoesNumero);

    const chatExistente = chats.find(chat => {
      const numeroChat = chat.mobile_number?.replace(/\D/g, '');
      return variacoesNumero.includes(numeroChat);
    });

    if (chatExistente) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('✅ [ABRIR CONVERSA] Conversa existente encontrada:', chatExistente.name);
      setSelectedChat(chatExistente);
      if (isMobile) {
        setShowMobileChat(true);
      }
      // Marcar como lido se necessário
      if (unreadCounts[chatExistente._id] && unreadCounts[chatExistente._id] > 0) {
        markChatAsRead(chatExistente._id);
      }
      setIsCreatingConversation(false);
      return;
    }

    // **ESTRATÉGIA 2: Criar lead real via sendTextMessage (cria lead automaticamente)**
    process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🆕 [ABRIR CONVERSA] Criando nova conversa real para:', dadosPedido.nome);

    // **🔧 TOAST ÚNICO DE CARREGAMENTO**
    const loadingToastId = toast.info(`🔄 ${t('toasts.startingConversation', { name: dadosPedido.nome })}`, {
      position: "top-right",
      autoClose: 8000, // Auto close em 8 segundos como fallback
    });

    try {
      const numeroParaEnvio = numeroComCodigo;
      const mensagemApresentacao = t('autoMessage.greeting', { name: dadosPedido.nome });

      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('📤 [ABRIR CONVERSA] Enviando mensagem de apresentação para:', numeroParaEnvio);

      // Usar sendTextMessage que cria o lead automaticamente
      const response = await sendTextMessageWhatsapp(empresaID, numeroParaEnvio, mensagemApresentacao, token);

      if (response.data && response.data.status === 200) {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('✅ [ABRIR CONVERSA] Mensagem enviada, lead criado automaticamente');

        // Aguardar um pouco para o lead ser criado
        setTimeout(async () => {
          try {
            // Recarregar a lista de chats para pegar o novo lead
            const chatsResponse = await getWhatsappChats(empresaID, 0, 30, '', token);

            if (chatsResponse.data?.messages?.[0]?.data) {
              const novosChats = chatsResponse.data.messages[0].data;

              // Procurar o chat recém-criado
              const chatCriado = novosChats.find(chat => {
                const numeroChat = chat.mobile_number?.replace(/\D/g, '');
                return variacoesNumero.includes(numeroChat);
              });

              if (chatCriado) {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log('✅ [ABRIR CONVERSA] Lead criado encontrado:', chatCriado.name);

                // Atualizar lista de chats
                setChats(novosChats);

                // Selecionar o chat criado
                setSelectedChat(chatCriado);
                if (isMobile) {
                  setShowMobileChat(true);
                }

                // Fechar toast de loading
                toast.dismiss(loadingToastId);

                // **🔧 TOAST ÚNICO DE SUCESSO**
                toast.success(`💬 ${t('toasts.conversationStarted', { name: dadosPedido.nome })}`, {
                  position: "top-right",
                  autoClose: 3000,
                });

                process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🎉 [ABRIR CONVERSA] Conversa criada e selecionada com sucesso');
              } else {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log('⚠️ [ABRIR CONVERSA] Chat criado não encontrado na lista atualizada');
                toast.dismiss(loadingToastId);
                showErrorToast(`⚠️ ${t('toasts.conversationCreatedNotFound')}`);
              }
            }
          } catch (reloadError) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error('❌ [ABRIR CONVERSA] Erro ao recarregar chats:', reloadError);
            toast.dismiss(loadingToastId);
            showErrorToast(`❌ ${t('toasts.locateConversationError')}`);
          }
        }, 2000); // 2 segundos para garantir que o lead seja criado

      } else {
        toast.dismiss(loadingToastId);
        throw new Error('Resposta inválida do servidor');
      }

    } catch (createError) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.error('❌ [ABRIR CONVERSA] Erro ao criar nova conversa:', createError);

      // **🔧 FECHAR TOAST DE LOADING**
      toast.dismiss(loadingToastId);

      // **🔧 ERRO ÚNICO CONSOLIDADO BASEADO NO TIPO**
      let errorMessage = `❌ ${t('toasts.startConversationError', { name: dadosPedido.nome })}`;

      if (createError.response?.status === 400) {
        errorMessage = `❌ ${t('toasts.invalidNumber', { phone: dadosPedido.celular })}`;
      } else if (createError.response?.status === 404) {
        errorMessage = `❌ ${t('toasts.numberNotFound', { phone: dadosPedido.celular })}`;
      } else if (createError.message?.includes('timeout')) {
        errorMessage = `❌ ${t('toasts.timeoutError')}`;
      } else if (createError.message?.includes('network')) {
        errorMessage = `❌ ${t('toasts.networkError')}`;
      }

      showErrorToast(errorMessage);
    } finally {
      // **🔧 SEMPRE LIMPAR ESTADO DE CRIAÇÃO**
      setIsCreatingConversation(false);

      // **🔧 LIMPAR LOCATION STATE APENAS SE AINDA EXISTIR**
      if (location.state) {
        navigate(location.pathname, { replace: true, state: null });
      }
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chats, empresaID, isMobile, unreadCounts, token, isCreatingConversation, navigate, location]); // Removido markChatAsRead e showErrorToast das dependências

  // **📌 Verificar se há dados do pedido para abrir conversa (MELHORADO PARA EVITAR LOOPS)**
  useEffect(() => {
    process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🎯 [DEBUG NAVIGATE] useEffect dados navigate executado:', {
      locationState: location.state,
      processedBefore: processedLocationRef.current,
      isLoged,
      loading,
      isCreatingConversation
    });

    // **🔧 SE LOCATION.STATE É NULL, RESETAR O PROCESSAMENTO**
    if (!location.state) {
      if (processedLocationRef.current !== null) {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🔄 [DEBUG NAVIGATE] Resetando processamento - location.state é null');
        processedLocationRef.current = null;
      }
      return;
    }

    // **🔧 VERIFICAR SE JÁ ESTÁ PROCESSANDO OU JÁ PROCESSOU**
    if (isCreatingConversation) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('⚠️ [DEBUG NAVIGATE] Já está criando conversa, ignorando...');
      return;
    }

    const locationKey = `${location.state.nome}-${location.state.celular}`;
    if (processedLocationRef.current === locationKey) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('⚠️ [DEBUG NAVIGATE] Já processou este location.state, ignorando...');
      return;
    }

    // **🔧 EXECUTAR APENAS SE TODAS AS CONDIÇÕES FOREM ATENDIDAS**
    if (location.state && location.state.nome && location.state.celular && isLoged && !loading) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('✅ [DEBUG NAVIGATE] Condições atendidas, abrindo conversa...');

      // **🔧 EXECUTAR IMEDIATAMENTE SEM DEBOUNCE**
      abrirOuCriarConversa(location.state).catch(error => {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.error('❌ [DEBUG NAVIGATE] Erro na função abrirOuCriarConversa:', error);
        showErrorToast(`❌ ${t('toasts.unexpectedError')}`);
      });

    } else {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('❌ [DEBUG NAVIGATE] Condições não atendidas:', {
        temLocationState: !!location.state,
        temNome: !!location.state?.nome,
        temCelular: !!location.state?.celular,
        estaLogado: isLoged,
        naoEstaCarregando: !loading
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state, isLoged, loading, isCreatingConversation]); // Removido abrirOuCriarConversa e showErrorToast das dependências

  // **📌 CLEANUP AO DESMONTAR COMPONENTE (MELHORADO)**
  useEffect(() => {
    return () => {
      // Limpar timeouts - copiar valores para variáveis locais
      const conversationTimeout = conversationTimeoutRef.current;
      const debounceTimeout = debounceTimeoutRef.current;

      if (conversationTimeout) {
        clearTimeout(conversationTimeout);
      }

      if (debounceTimeout) {
        clearTimeout(debounceTimeout);
      }

      // Cancelar toast pendente
      if (lastErrorToastRef.current) {
        toast.dismiss(lastErrorToastRef.current);
      }

      // Limpar refs
      processedLocationRef.current = null;
      lastErrorMessageRef.current = '';
      lastErrorTimeRef.current = 0;
    };
  }, []);

  // **📌 LIMPAR PROCESSED LOCATION AO MUDAR DE ROTA OU PÁGINA**
  useEffect(() => {
    // Reset sempre que mudar o pathname
    const previousPath = processedLocationRef.current;
    processedLocationRef.current = null;
    lastErrorMessageRef.current = '';
    lastErrorTimeRef.current = 0;

    if (previousPath !== null) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🔄 [DEBUG NAVIGATE] Reset completo ao mudar pathname');
    }
  }, [location.pathname]);

  return (
    <>
      <S.GlobalStyles />
      {/*<LeftMenu setSidebar={setSidebar} sidebar={sidebar} />*/}
      <Teste sidebar={sidebar}>
        {!isLoged && !checkingConnection ?
          <SyncContainer>
            <SyncCard>
              {/* Header elegante com logo WhatsApp */}
              <SyncHeader>
                <SyncHeaderContent>
                  <WhatsAppLogo>
                    <FaWhatsapp />
                  </WhatsAppLogo>
                  <SyncHeaderText>
                    <h1>WhatsApp Web</h1>
                    <p>{t('qrCode.title')}</p>
                  </SyncHeaderText>
                </SyncHeaderContent>
              </SyncHeader>

              <SyncBody>
                {/* Lista de passos com animação staggered */}
                <StepsList>
                  <StepItem $delay="0.1s">
                    <StepNumber>1</StepNumber>
                    <StepText>{t('qrCode.steps.step1')}</StepText>
                  </StepItem>
                  <StepItem $delay="0.2s">
                    <StepNumber>2</StepNumber>
                    <StepText>{t('qrCode.steps.step2')}</StepText>
                  </StepItem>
                  <StepItem $delay="0.3s">
                    <StepNumber>3</StepNumber>
                    <StepText>{t('qrCode.steps.step3')}</StepText>
                  </StepItem>
                  <StepItem $delay="0.4s">
                    <StepNumber>4</StepNumber>
                    <StepText>{t('qrCode.steps.step4')}</StepText>
                  </StepItem>
                </StepsList>

                {/* Container do QR Code */}
                <QRCodeWrapper>
                  <QRCodeContainer>
                    <QRCodeInner $expired={qrCodeExpired}>
                      {generatingQrCode ? (
                        <LoadingState>
                          <LoadingSpinner />
                          <LoadingText>
                            <h4>{t('qrCode.generatingQrCode')}</h4>
                            <p>{t('qrCode.waitPreparing')}</p>
                          </LoadingText>
                        </LoadingState>
                      ) : qrCodeImg ? (
                        <>
                          <img
                            src={qrCodeImg}
                            alt="QR Code"
                            onLoad={() => process.env.REACT_APP_ISDEVELOP === 'true' && console.log('QR Code carregado com sucesso')}
                            onError={(e) => {
                              process.env.REACT_APP_ISDEVELOP === 'true' && console.error('Erro ao carregar QR Code:', e);
                            }}
                          />
                          {qrCodeExpired && !generatingQrCode && (
                            <QRCodeExpired>
                              <div className="icon">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                  <circle cx="12" cy="12" r="10" />
                                  <polyline points="12,6 12,12 16,14" />
                                </svg>
                              </div>
                              <span className="text">{t('qrCode.expired')}</span>
                              <span className="subtext">{t('qrCode.clickToGenerate')}</span>
                            </QRCodeExpired>
                          )}
                        </>
                      ) : userRequestedQrCode && qrCodeFailed ? (
                        <InitialState>
                          <InitialIcon>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <circle cx="12" cy="12" r="10" />
                              <line x1="12" y1="8" x2="12" y2="12" />
                              <line x1="12" y1="16" x2="12.01" y2="16" />
                            </svg>
                          </InitialIcon>
                          <InitialTitle>{t('qrCode.connectionStuck', 'Conexão travada')}</InitialTitle>
                          <InitialSubtitle>{t('qrCode.connectionStuckDesc', 'A instância WhatsApp não respondeu. Clique para reconectar.')}</InitialSubtitle>
                          <GenerateButton onClick={() => regenerateQrCodeViaAPI('stuck_retry')}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="20" height="20">
                              <path d="M21 2v6h-6" />
                              <path d="M3 12a9 9 0 0 1 15-6.7L21 8" />
                              <path d="M3 22v-6h6" />
                              <path d="M21 12a9 9 0 0 1-15 6.7L3 16" />
                            </svg>
                            <span>{t('qrCode.reconnect', 'Reconectar')}</span>
                          </GenerateButton>
                        </InitialState>
                      ) : userRequestedQrCode ? (
                        <LoadingState>
                          <LoadingSpinner />
                          <LoadingText>
                            <h4>{t('qrCode.generatingQrCode')}</h4>
                            <p>{t('qrCode.waitPreparing')}</p>
                          </LoadingText>
                        </LoadingState>
                      ) : (
                        <InitialState>
                          <InitialIcon>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <rect x="3" y="3" width="7" height="7" />
                              <rect x="14" y="3" width="7" height="7" />
                              <rect x="14" y="14" width="7" height="7" />
                              <rect x="3" y="14" width="7" height="7" />
                            </svg>
                          </InitialIcon>
                          <InitialTitle>{t('qrCode.readyToConnect')}</InitialTitle>
                          <InitialSubtitle>{t('qrCode.clickButtonBelow')}</InitialSubtitle>
                          <GenerateButton onClick={generateQrCodeManually}>
                            <FaWhatsapp />
                            <span>{t('qrCode.generate')}</span>
                          </GenerateButton>
                        </InitialState>
                      )}
                    </QRCodeInner>

                    {/* Timer elegante */}
                    {!qrCodeExpired && qrCodeTimeLeft > 0 && qrCodeImg && (
                      <QRCodeTimer $critical={qrCodeTimeLeft <= 10}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <circle cx="12" cy="12" r="10" />
                          <polyline points="12,6 12,12 16,14" />
                        </svg>
                        <span>
                          {t('qrCode.expiresIn')} {Math.floor(qrCodeTimeLeft / 60)}:{(qrCodeTimeLeft % 60).toString().padStart(2, '0')}
                        </span>
                      </QRCodeTimer>
                    )}

                    {/* Botão de regenerar */}
                    {qrCodeImg && (qrCodeExpired || showRegenerateButton) && (
                      <RegenerateButton
                        onClick={() => regenerateQrCodeViaAPI('manual')}
                        disabled={generatingQrCode}
                        $generating={generatingQrCode}
                      >
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M21 2v6h-6" />
                          <path d="M3 12a9 9 0 0 1 15-6.7L21 8" />
                          <path d="M3 22v-6h6" />
                          <path d="M21 12a9 9 0 0 1-15 6.7L3 16" />
                        </svg>
                        <span>{generatingQrCode ? t('qrCode.generatingShort') : t('qrCode.generateNew')}</span>
                      </RegenerateButton>
                    )}
                  </QRCodeContainer>
                </QRCodeWrapper>
              </SyncBody>
            </SyncCard>
          </SyncContainer>
          :
          <WhatsAppContainer>
            <WrapperContainerAll>

              <WrapperHMC isMobile={isMobile} showMobileChat={showMobileChat}>

                <WrapperListHeader>
                  <HeaderListHeader>
                    <UserImage onClick={openMenu}>
                      <img
                        src={myProfilePicture || userParse?.user_img[0] || userIcon}
                        width="35"
                        height="35"
                        alt={t('profile.userPhoto')}
                        onError={(e) => {
                          // Se a imagem falhar ao carregar (403 = URL expirada/sem permissão)
                          if (e.target.src !== userIcon) {
                            e.target.src = userIcon;

                            // 🔧 Limpar cache imediatamente - URL quebrada não deve persistir
                            setMyProfilePicture(null);
                            localStorage.removeItem(`my_profile_picture_${empresaID}`);
                            localStorage.removeItem(`my_profile_picture_timestamp_${empresaID}`);
                            console.log(`🧹 Foto de perfil removida do cache (URL retornou erro 403)`);
                          }
                        }}
                        onDoubleClick={() => {
                          // Duplo clique para forçar atualização da imagem
                          process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`🔄 Forçando atualização da minha imagem de perfil`);
                          fetchMyProfilePicture(true);
                        }}
                      />
                    </UserImage>
                    <Actions ref={menuRef}>
                      <StatusIcon role="img" aria-label={t('ariaLabels.openStatus')} />
                      <ChatIcon role="img" aria-label={t('ariaLabels.newConversation')} />
                      <MenuIcon
                        role="img"
                        aria-label={t('ariaLabels.expandMenu')}
                        onClick={() => setIsMenuOpen(true)}
                      />
                    </Actions>
                  </HeaderListHeader>
                </WrapperListHeader>

                <WrapperMenu className={isMenuOpen ? "active" : ""}>
                  <ActionWrapperMenu>
                    <ActionMenu
                      key="profile"
                      onClick={openMenu}
                    >
                      {t('menu.profile')}
                    </ActionMenu>
                    <ActionMenu
                      key="disconnect"
                      onClick={handleDisconnect}
                    >
                      {t('menu.disconnect')}
                    </ActionMenu>
                  </ActionWrapperMenu>
                </WrapperMenu>

                <SearchBar
                  searchQuery={searchQuery}
                  setSearchQuery={setSearchQuery}
                  placeholder={t('chat.searchPlaceholder')}
                  cancelText={t('chat.searchCancel')}
                />

                {/* 📌 INDICADOR DE PRÉ-CARREGAMENTO */}
                {preloadingChats && (
                  <div style={{
                    padding: '8px 16px',
                    backgroundColor: '#f0f8f0',
                    borderLeft: '3px solid #25D366',
                    fontSize: '12px',
                    color: '#666',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}>
                    <Loading type="spin" color="#25D366" height={12} width={12} />
                    <span>
                      {t('chat.preloadingConversations')} ({preloadProgress.current}/{preloadProgress.total})
                    </span>
                  </div>
                )}

                {/* 📌 Adicionamos `ref={chatsContainerRef}` para detectar o scroll */}
                <div className="containerChatsWhatsapp" ref={chatsContainerRef}>
                  {/* Loading inicial dos chats */}
                  {loading && chats.length === 0 && (
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: '40px 20px',
                      color: '#666'
                    }}>
                      <Loading type="spin" color="#25D366" height={40} width={40} />
                      <p style={{ marginTop: '15px', fontSize: '14px' }}>{t('chat.loadingConversations')}</p>
                    </div>
                  )}

                  {chats.map((chat) => (
                    <WrapperListContacts key={chat._id}
                      isSelected={chat._id === selectedChat?._id}
                      onClick={() => {
                        if (isMobile) {
                          handleSelectChatMobile(chat);
                        } else {
                          setSelectedChat(chat);
                          // **📌 MARCAR MENSAGENS COMO LIDAS AO SELECIONAR CHAT (DESKTOP)**
                          if (unreadCounts[chat._id] && unreadCounts[chat._id] > 0) {
                            markChatAsRead(chat._id);
                          }
                        }
                      }}
                      onContextMenu={(e) => handleRightClick(e, chat)}>
                      <ContactPhotoListContacts>
                        <UnreadBadge count={unreadCounts[chat._id] || 0}>
                          <img
                            src={(() => {
                              const pic = chat.channel_data?.whatsapp?.profile_picture;
                              // Não usar URLs que já falharam (evita 403 repetidos)
                              if (pic && window.imgFailedCache?.[`img_failed_${chat._id}`]) return userIcon;
                              return pic || userIcon;
                            })()}
                            width="60"
                            alt={t('profile.userPhoto')}
                            onError={(e) => {
                              // Se a imagem falhar ao carregar (403 = URL expirada)
                              if (e.target.src !== userIcon) {
                                e.target.src = userIcon;

                                // Limpar URL expirada do state imediatamente
                                setChats(prevChats =>
                                  prevChats.map(c =>
                                    c._id === chat._id
                                      ? {
                                        ...c,
                                        channel_data: {
                                          ...c.channel_data,
                                          whatsapp: {
                                            ...c.channel_data?.whatsapp,
                                            profile_picture: null
                                          }
                                        }
                                      }
                                      : c
                                  )
                                );

                                // Evitar múltiplas tentativas de fetch para a mesma imagem
                                const failedKey = `img_failed_${chat._id}`;
                                const lastFailTime = window.imgFailedCache?.[failedKey] || 0;
                                const now = Date.now();

                                // Só tenta buscar nova imagem a cada 60 segundos
                                if (now - lastFailTime > 60000) {
                                  if (!window.imgFailedCache) window.imgFailedCache = {};
                                  window.imgFailedCache[failedKey] = now;
                                  process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`❌ Imagem expirada para ${chat.name}, buscando nova...`);
                                  fetchProfilePicture(chat, true); // forceUpdate para pegar URL fresca
                                }
                              }
                            }}
                            onDoubleClick={() => {
                              // Duplo clique para forçar atualização da imagem
                              process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`🔄 Forçando atualização da imagem de perfil para ${chat.name}`);
                              fetchProfilePicture(chat, true); // forceUpdate = true
                            }}
                            title={t('tooltips.doubleClickUpdatePhoto')}
                          />
                        </UnreadBadge>
                      </ContactPhotoListContacts>
                      <MessageDataWrapper>
                        <ContactNameAndTime>
                          <span
                            onDoubleClick={() => {
                              process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`🔄 Atualizando informações do contato ${chat.name} via duplo clique`);
                              refreshContactInfo(chat._id, chat.name);
                            }}
                            title={t('tooltips.doubleClickUpdateContact')}
                            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px' }}
                          >
                            {chat.name}
                            {hasGenericName(chat.name, chat.mobile_number) && (
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  refreshContactInfo(chat._id, chat.name);
                                }}
                                style={{
                                  background: 'transparent',
                                  border: 'none',
                                  cursor: 'pointer',
                                  color: '#FFA500',
                                  fontSize: '12px',
                                  padding: '0',
                                  margin: '0',
                                  opacity: 0.7,
                                  transition: 'opacity 0.2s ease'
                                }}
                                onMouseOver={(e) => e.target.style.opacity = 1}
                                onMouseOut={(e) => e.target.style.opacity = 0.7}
                                title={t('tooltips.genericNameHint')}
                              >
                                🔍
                              </button>
                            )}
                          </span>
                          <p>{chat.message ? formatDate(chat.message.messageDate || chat.message.createdAt) : ''}</p>
                        </ContactNameAndTime>
                        <ContactMessage>
                          {chat.message && chat.message.fromMe && <CheckIcon />}
                          <p>{chat.message ? (chat.message.message || chat.message.text || t('chat.newConversation')) : t('chat.newConversation')}</p>
                        </ContactMessage>
                      </MessageDataWrapper>
                    </WrapperListContacts>
                  ))}

                  {/* **📌 Indicador de carregamento enquanto busca mais chats** */}
                  {loadingMore && (
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                      padding: '12px',
                      color: '#667781',
                      fontSize: '13px'
                    }}>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        style={{ animation: 'spin 1s linear infinite', color: '#25D366' }}
                      >
                        <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2"/>
                      </svg>
                      <span>{t('chat.loadingMoreConversations')}</span>
                    </div>
                  )}
                </div>

              </WrapperHMC>

              {(selectedChat && (!isMobile || showMobileChat)) ?
                <WrapperContainerConversa
                  isMobile={isMobile}
                  showMobileChat={showMobileChat}
                  backgroundLoaded={backgroundLoaded}
                >

                  <Header>
                    <MobileBackButton onClick={handleBackToList}>
                      <BackIcon />
                    </MobileBackButton>
                    <ContactPhoto onClick={handleOpenProfile} style={{ cursor: "pointer" }}>
                      <img
                        src={(() => {
                          const pic = selectedChat.channel_data?.whatsapp?.profile_picture;
                          if (pic && window.imgFailedCache?.[`img_failed_${selectedChat._id}`]) return userIcon;
                          return pic || userIcon;
                        })()}
                        width="40"
                        alt={t('profile.userPhoto')}
                        onError={(e) => {
                          // Se a imagem falhar ao carregar (403 = URL expirada)
                          if (e.target.src !== userIcon) {
                            e.target.src = userIcon;

                            // Limpar URL expirada do selectedChat imediatamente
                            setSelectedChat(prev => prev ? ({
                              ...prev,
                              channel_data: {
                                ...prev.channel_data,
                                whatsapp: {
                                  ...prev.channel_data?.whatsapp,
                                  profile_picture: null
                                }
                              }
                            }) : prev);

                            // Evitar múltiplas tentativas de fetch para a mesma imagem
                            const failedKey = `img_failed_${selectedChat._id}`;
                            const lastFailTime = window.imgFailedCache?.[failedKey] || 0;
                            const now = Date.now();

                            // Só tenta buscar nova imagem a cada 60 segundos
                            if (now - lastFailTime > 60000) {
                              if (!window.imgFailedCache) window.imgFailedCache = {};
                              window.imgFailedCache[failedKey] = now;
                              process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`❌ Imagem expirada para ${selectedChat.name}, buscando nova...`);
                              fetchProfilePicture(selectedChat, true); // forceUpdate para pegar URL fresca
                            }
                          }
                        }}
                        onDoubleClick={(e) => {
                          // Duplo clique para forçar atualização da imagem (evitar abrir perfil)
                          e.stopPropagation();
                          process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`🔄 Forçando atualização da imagem de perfil para ${selectedChat.name}`);
                          fetchProfilePicture(selectedChat, true); // forceUpdate = true
                        }}
                        title={t('tooltips.clickToViewProfile')}
                      />
                    </ContactPhoto>
                    <ContactName
                      onClick={handleOpenProfile}
                      style={{ cursor: 'pointer' }}
                      title={t('tooltips.clickToViewProfile')}
                    >
                      {selectedChat.name}
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          refreshContactInfo(selectedChat._id, selectedChat.name);
                        }}
                        disabled={refreshingContact}
                        style={{
                          background: 'transparent',
                          border: 'none',
                          marginLeft: '6px',
                          cursor: refreshingContact ? 'wait' : 'pointer',
                          color: refreshingContact ? '#25D366' : '#8696a0',
                          fontSize: '14px',
                          padding: '4px',
                          borderRadius: '50%',
                          transition: 'all 0.2s ease',
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '24px',
                          height: '24px',
                          animation: refreshingContact ? 'spin 1s linear infinite' : 'none'
                        }}
                        onMouseOver={(e) => { if (!refreshingContact) { e.currentTarget.style.color = '#25D366'; e.currentTarget.style.background = 'rgba(37, 211, 102, 0.1)'; } }}
                        onMouseOut={(e) => { if (!refreshingContact) { e.currentTarget.style.color = '#8696a0'; e.currentTarget.style.background = 'transparent'; } }}
                        title={refreshingContact ? t('tooltips.updatingContactInfo') : t('tooltips.updateContactInfo')}
                      >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2"/>
                        </svg>
                      </button>
                    </ContactName>
                  </Header>

                  <WrapperContent
                    ref={messagesContainerRef}
                    onScroll={handleMessagesScroll}
                  >
                    {loadingMessages ? (
                      <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%',
                        color: '#666',
                        gap: '15px'
                      }}>
                        <Loading type="spin" color="#25D366" height={40} width={40} />
                        <p style={{ fontSize: '14px', textAlign: 'center' }}>
                          {t('chat.loadingMessages', { name: selectedChat.name })}
                        </p>
                      </div>
                    ) : Object.keys(groupedMessages).length > 0 ? (
                      <>
                        {/* **📌 INDICADOR DE CARREGAMENTO DE MAIS MENSAGENS** */}
                        {loadingMoreMessages && (
                          <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: '15px',
                            color: '#667781',
                            fontSize: '13px',
                            gap: '8px'
                          }}>
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              style={{ animation: 'spin 1s linear infinite', color: '#25D366' }}
                            >
                              <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2"/>
                            </svg>
                            <span>{t('chat.loadingPreviousMessages')}</span>
                          </div>
                        )}

                        {/* **📌 INDICADOR QUANDO NÃO HÁ MAIS MENSAGENS** */}
                        {!hasMoreMessages && messagesLeadChannel.length > 30 && (
                          <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: '15px',
                            color: '#999',
                            fontSize: '12px',
                            fontStyle: 'italic'
                          }}>
                            📜 {t('chat.startOfConversation')}
                          </div>
                        )}

                        {Object.keys(groupedMessages).map((date) => (
                          <React.Fragment key={date}>
                            <ChatDate>{toTz(date).calendar(null, {
                              sameDay: `[${t('dates.today')}]`,
                              lastDay: `[${t('dates.yesterday')}]`,
                              lastWeek: 'dddd',
                              sameElse: i18n.language === 'en-US' ? 'MM/DD/YYYY' : 'DD/MM/YYYY'
                            })}</ChatDate>
                            {groupedMessages[date].map((message) => {
                              const { _id, text, createdAt, fromMe, isOptimistic, status } = message;
                              return (
                                <Message key={_id} fromMe={fromMe}>
                                  <p>{text}</p>
                                  <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    {formatDateTz(createdAt, 'HH:mm')}
                                    {fromMe && isOptimistic && status === 'sending' && (
                                      <span title={t('chat.sendingStatus')} style={{ color: '#999', fontSize: '10px' }}>⏳</span>
                                    )}
                                    {fromMe && isOptimistic && status === 'sent' && (
                                      <span title={t('chat.sentStatus')} style={{ color: '#25D366', fontSize: '10px' }}>✓</span>
                                    )}
                                    {fromMe && !isOptimistic && (
                                      <span title={t('chat.deliveredStatus')} style={{ color: '#25D366', fontSize: '10px' }}>✓✓</span>
                                    )}
                                  </span>
                                </Message>
                              );
                            })}
                          </React.Fragment>
                        ))}
                        <div ref={messageEndRef} />
                      </>
                    ) : (
                      <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%',
                        color: '#999',
                        textAlign: 'center',
                        padding: '40px 20px'
                      }}>
                        <div style={{
                          fontSize: '48px',
                          marginBottom: '20px',
                          opacity: 0.5
                        }}>
                          💬
                        </div>
                        <p style={{
                          fontSize: '18px',
                          marginBottom: '8px',
                          fontWeight: '500',
                          color: '#666'
                        }}>
                          {t('chat.noMessagesYet')}
                        </p>
                        <p style={{
                          fontSize: '14px',
                          lineHeight: '1.4',
                          maxWidth: '280px'
                        }}
                          dangerouslySetInnerHTML={{ __html: t('chat.newConversationWith', { name: selectedChat.name }) }}
                        />
                      </div>
                    )}
                  </WrapperContent>

                  <WrapperChat>
                    <form onSubmit={handleSubmit} style={{ display: "flex", alignItems: "center", gap: 10, width: "100%" }}>
                      <Input
                        type="text"
                        placeholder={t('chat.typeMessage')}
                        onChange={({ target }) => setMessage(target.value)}
                        value={message}
                        style={{ fontSize: '15px', flex: 1, borderRadius: '8px', padding: '9px 12px' }}
                      />

                      <button
                        type="submit"
                        disabled={isSubmitting || !message.trim()}
                        style={{
                          background: "transparent",
                          border: "none",
                          cursor: isSubmitting || !message.trim() ? "not-allowed" : "pointer",
                          color: isSubmitting || !message.trim() ? "#ccc" : "#54656f",
                          fontSize: isMobile ? "22px" : "24px",
                          opacity: isSubmitting || !message.trim() ? 0.6 : 1,
                          padding: "8px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {isSubmitting ? (
                          <Loading type="spin" color="#25D366" height={20} width={20} />
                        ) : (
                          <FiSend />
                        )}
                      </button>

                      {/* Botão de Pausar/Reativar o Bot */}
                      <button
                        type="button"
                        onClick={() => handleToggleBot(selectedChat._id)}
                        style={{
                          background: "transparent",
                          border: botPausado ? "1px solid #FF4D4D" : "1px solid #25D366",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: 5,
                          color: botPausado ? "#FF4D4D" : "#25D366", // Vermelho se pausado, branco se ativo
                          fontSize: isMobile ? "12px" : "14px",
                          fontWeight: '600',
                          minWidth: isMobile ? 120 : 140,
                          justifyContent: 'center',
                          borderRadius: 8,
                          padding: isMobile ? '8px' : '10px'
                        }}
                      >
                        {botPausado ? <FiPauseCircle style={{ fontSize: 17 }} /> : <FiPlayCircle style={{ fontSize: 17 }} />}
                        <span>{botPausado ? t('bot.paused') : t('bot.active')}</span>
                      </button>
                    </form>
                  </WrapperChat>
                  {/* Modal do Perfil */}
                  <UserProfile
                    isOpen={isProfileOpen}
                    onClose={() => setIsProfileOpen(false)}
                    user={selectedChat}
                    empresaID={empresaID}
                    onNameUpdate={(leadId, newName) => {
                      // Atualizar o chat selecionado
                      setSelectedChat(prev => prev?._id === leadId ? { ...prev, name: newName } : prev);
                      // Atualizar a lista de chats
                      setChats(prevChats => prevChats.map(c => c._id === leadId ? { ...c, name: newName } : c));
                    }}
                  />
                </WrapperContainerConversa>
                :
                (!isMobile || !showMobileChat) && <WrapperContainerConversa
                  backgroundLoaded={backgroundLoaded}
                  style={{
                    background: 'white',
                    justifyContent: 'center',
                    display: isMobile ? 'none' : 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                  }}
                >
                  <FaWhatsapp style={{ fontSize: '100px', color: 'rgba(0, 0, 0, 0.45)' }} />
                  <Warn style={{ background: 'white' }}>{t('chat.selectConversation')}</Warn>
                </WrapperContainerConversa>
              }

            </WrapperContainerAll>

            {isOpen && (
              <S.Wrapper>
                <S.Header>
                  <S.Back>
                    <BackIcon onClick={closeMenu} />
                    <h3>{t('profile.title')}</h3>
                  </S.Back>
                </S.Header>

                <S.UserImage>
                  <img
                    src={myProfilePicture || userParse?.user_img[0] || userIcon}
                    width="200"
                    height="200"
                    alt={t('profile.userPhoto')}
                    onError={(e) => {
                      // Se a imagem falhar ao carregar (403 = URL expirada/sem permissão)
                      if (e.target.src !== userIcon) {
                        e.target.src = userIcon;

                        // 🔧 Limpar cache imediatamente - URL quebrada não deve persistir
                        setMyProfilePicture(null);
                        localStorage.removeItem(`my_profile_picture_${empresaID}`);
                        localStorage.removeItem(`my_profile_picture_timestamp_${empresaID}`);
                        console.log(`🧹 Foto de perfil removida do cache (URL retornou erro 403) - modal`);
                      }
                    }}
                    onDoubleClick={() => {
                      // Duplo clique para forçar atualização da imagem
                      process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`🔄 Forçando atualização da minha imagem de perfil no modal`);
                      fetchMyProfilePicture(true);
                    }}
                    style={{ cursor: 'pointer' }}
                  />
                </S.UserImage>

                <S.UserData>
                  <span>{t('profile.name')}</span>
                  <p>{empresaParse.name}</p>
                </S.UserData>

                <S.UserData>
                  <span>{t('profile.status')}</span>
                  <p>{t('profile.defaultStatus')}</p>
                </S.UserData>
              </S.Wrapper>
            )}
          </WhatsAppContainer>
        }

        {checkingConnection && (
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(255, 255, 255, 0.6)',
            backdropFilter: 'blur(4px)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '14px',
            zIndex: 10,
          }}>
            <Loading type="spin" color="#25D366" height={44} width={44} />
            <span style={{ color: '#475569', fontSize: '14px', fontWeight: 600 }}>
              {t('chat.checkingConnection', { defaultValue: 'Verificando conexão...' })}
            </span>
          </div>
        )}

        {/* **📌 MENU DE CONTEXTO (BOTÃO DIREITO)** */}
        {contextMenu.visible && (
          <div
            style={{
              position: 'fixed',
              top: contextMenu.y,
              left: contextMenu.x,
              backgroundColor: 'white',
              border: '1px solid #ddd',
              borderRadius: '6px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
              zIndex: 10000,
              minWidth: '160px',
              overflow: 'hidden'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              onClick={handleDeleteMessages}
              style={{
                padding: '12px 16px',
                cursor: 'pointer',
                fontSize: '14px',
                color: '#dc3545',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                transition: 'background-color 0.2s ease',
                userSelect: 'none'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#f8f9fa';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
              }}
            >
              🗑️ {t('contextMenu.deleteMessages')}
            </div>
          </div>
        )}

        <GlobalStyles />

      </Teste>
    </>
  );
}

export default WhatsAppWeb;